/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params, language) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = language || (typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl');
        var dict = require('../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/* MOJE KUPONY — notatnik zestawow (Fala 1, 24.09.2026).
 *
 * Jeden wersjonowany magazyn w localStorage dla generatora, sprawdzarki kuponu,
 * analizatora zestawu i stron wynikow. Wyodrebniony z pages/analizator-zestawy.js,
 * ktory do dzis trzymal zestawy wlasnym kluczem `pewniaki:analizator:v1:<gra>`.
 *
 * KLUCZ `pewniaki:moje-zestawy:v2`, jeden dla wszystkich gier:
 *   { "version": 2,
 *     "games": { "<kod gry>": [ { "id", "name", "numbers": [..], "extra": [..],
 *                                 "source", "created" } ] },
 *     "migratedV1": { "<kod gry>": true } }
 *
 * ZASADY
 *   - Liczby uzytkownika nie trafiaja do URL, logow ani analityki. Opcjonalny
 *     przycisk „Wstaw najczestsze" pobiera przez osobny modul tylko publiczna
 *     historie wynikow; niczego nie wysyla. Zdarzenia GA4 niosa wylacznie kod
 *     gry, zrodlo widoku i przedzial liczby zestawow (biala lista nizej).
 *   - Parametry gier pochodza z JEDNEGO zrodla: slownikGier() w dane.php,
 *     podanego stronie przez layout/_moje-zestawy.html.twig. Reguly zapisu
 *     sklada JEDEN adapter — reguly() nizej.
 *   - Migracja z v1 jest idempotentna: znacznik `migratedV1[gra]` zapisuje sie
 *     w tym samym setItem co przeniesione zestawy, a stary klucz zostaje nietkniety.
 *   - Uszkodzony JSON, brak localStorage i QuotaExceededError nie psuja strony:
 *     odczyt daje pusta liste, zapis zwraca kod bledu dla komunikatu.
 *   - Po kazdej zmianie leci zdarzenie DOM `pewniaki:zestawy-zmiana`
 *     (detail.game), wiec kilka widokow na jednej stronie odswieza sie samo.
 *
 * OSTATNIO WIDZIANE LOSOWANIE (Fala 2, 24.09.2026) — osobny klucz
 * `pewniaki:ostatnie-widziane:v1`: { "<kod gry>": "<ID losowania>" }.
 * Wylacznie ID (same cyfry) — zadnych liczb, nazw zestawow ani dat. Schemat
 * v2 zestawow bez zmian. Nowy wynik = INNE ID niz zapisane (nie data: gra
 * moze miec dwa losowania dnia). Stan powstaje tylko dla gry z zapisanymi
 * zestawami; pierwsza wizyta zapisuje ID bez komunikatu; brak/bledne ID
 * na stronie nic nie pokazuje i niczego nie nadpisuje. Decyzja: ocenWidziane().
 *
 * MOJE GRY NA STRONIE GLOWNEJ (Fala 3, 24.09.2026) — widokMojeGry(): najwyzej
 * trzy gry z zapisami, kolejnosc: wiecej zestawow wyzej, remis = kolejnosc
 * slownika gier. Stan „nowy wynik” wylacznie z ODCZYTU klucza widzianych —
 * strona glowna niczego w nim nie zapisuje.
 *
 * STALY SKROT „MOJE KUPONY" (Fala 4.3A, 25.09.2026) — widokSkrot(): na kazdej
 * zwyklej stronie (partial wlacza layout.html.twig) przycisk przy dolnej
 * krawedzi z licznikiem zestawow i <dialog> z lista gier i zestawow. Ten sam
 * magazyn i ta sama walidacja. Skrot jest widoczny także przy pustym magazynie,
 * aby użytkownik od razu mógł dodać pierwszy zestaw albo otworzyć pomoc.
 *
 * Test: node bin/test-moje-zestawy.js (czesc bez DOM),
 *       node ai/test-moje-zestawy-dom.js, node ai/test-fala-4-3a-dom.js (przegladarka).
 */
(function (root, fabryka) {
    'use strict';
    var api = fabryka(root);
    if (typeof module === 'object' && module && module.exports) { module.exports = api; }
    root.PewniakiZestawy = api;
    if (root.document && root.document.getElementById) { api.startStrony(root.document); }
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
    'use strict';

    var KLUCZ = 'pewniaki:moje-zestawy:v2';
    var KLUCZ_V1 = 'pewniaki:analizator:v1:';
    var KLUCZ_USZKODZONY = KLUCZ + ':uszkodzony';
    var WERSJA = 2;
    var LIMIT = 20;
    var NAZWA_MAX = 60;
    var ZDARZENIE = 'pewniaki:zestawy-zmiana';
    var ZRODLA = ['generator', 'sprawdzarka', 'analizator', 'wyniki', 'import', 'panel'];
    var KLUCZ_WIDZIANE = 'pewniaki:ostatnie-widziane:v1';
    // RUCH-1 (1.10.2026, decyzja daro #3): `ticket_check` = reczne sprawdzenie
    // kuponu (sprawdz-kupon.html.twig, klik „Sprawdz" z liczbami i losowaniem),
    // `quick_pick` = losowanie w generatorze (generator.html.twig). Te same
    // parametry co reszta listy: kod gry, zrodlo widoku, przedzial liczby
    // zestawow — zadnych liczb gracza. Wolane przez PewniakiZestawy.sklep().zdarzenie().
    var ZDARZENIA_GA4 = ['my_ticket_open', 'my_ticket_save', 'my_ticket_load', 'my_ticket_check_latest', 'my_ticket_summary_view', 'result_followup_click', 'my_ticket_history', 'result_share', 'ticket_check', 'ticket_check_all', 'quick_pick', 'result_range_change', 'result_sketch_open', 'result_sketch_add', 'frequent_numbers_use', 'result_random_numbers'];
    var ZRODLA_GA4 = ['generator', 'sprawdzarka', 'analizator', 'wyniki', 'centrum'];
    var TRYBY_GA4 = ['checker', 'report', 'changes', 'analyser', 'frequent', 'random', 'manual'];
    var ZAKRESY_GA4 = ['7', '14', '25', '50', '100', '250', '500', 'all', 'custom'];
    // Fala 6A (26.09.2026)
    var FORMAT_PAKIETU = 'pewniaki-moje-kupony';
    var IMPORT_MAX = 500;                         // zestawow jednej gry w pliku — ochrona przed smieciem
    var KLUCZ_PRZEKAZ = 'pewniaki:moje-kupony:przekaz:v1';
    var PRZEKAZ_MS = 10 * 60 * 1000;
    var CELE_PRZEKAZU = ['sprawdzarka', 'analiza', 'raport'];
    var KLUCZ_WSKAZOWKA = 'pewniaki:moje-kupony:wskazowka:v1';

    function calkowita(v) { return typeof v === 'number' && isFinite(v) && Math.floor(v) === v; }
    /** "7" -> 7, 7 -> 7, 0 -> 0 (zero to wartosc, nie brak); "", null, 1.5, "7a" -> NaN. */
    function liczba(v) {
        if (typeof v === 'number') { return v; }
        if (typeof v === 'string' && /^\s*\d{1,6}\s*$/.test(v)) { return parseInt(v, 10); }
        return NaN;
    }
    function kopia(x) { return x === undefined ? undefined : JSON.parse(JSON.stringify(x)); }
    function rosnaco(a, b) { return a - b; }

    /* ── ADAPTER REGUL GRY (jedyne miejsce) ─────────────────────────────────
       Wejscie: wpis slownikGier() {code, name, pool_max, pick_count,
       special_count, special_max}. `pick_count` to liczba liczb w losowaniu —
       tyle zapisuje generator i analizator. Dwa wyjatki wynikaja z kuponu:
         - Multi Multi: na kuponie 1-10 skreslen (limit() w sprawdzarce), a
           liczba „Plus" to jedna z 20 wylosowanych, nie osobny wybor gracza —
           dlatego bez liczb dodatkowych; 20 zostaje dla zestawow z generatora
           i analizatora;
         - osobna pula dodatkowa (dzis tylko Eurojackpot, 2 z 12): liczby
           dodatkowe sa opcjonalne, bo analizator zapisywal same glowne.
       `kupon` = najwiecej liczb, ile przyjmie siatka sprawdzarki. */
    function reguly(p) {
        if (!p || typeof p.code !== 'string' || !/^[a-z][a-z0-9-]{0,30}$/.test(p.code)) { return null; }
        var pula = liczba(p.pool_max), ile = liczba(p.pick_count);
        var pulaD = liczba(p.special_max), ileD = liczba(p.special_count);
        if (!calkowita(pula) || !calkowita(ile) || pula < 1 || ile < 1 || ile > pula) { return null; }
        var r = { kod: p.code, nazwa: String(p.name || p.code), pula: pula, pick: ile, ile: [ile], kupon: ile, dodatkowe: null };
        if (p.code === 'multi-multi') {
            r.ile = [];
            for (var i = 1; i <= Math.min(10, pula); i++) { r.ile.push(i); }
            if (r.ile.indexOf(ile) < 0) { r.ile.push(ile); }
            r.kupon = Math.min(10, pula);
        } else if (calkowita(pulaD) && calkowita(ileD) && ileD > 0 && pulaD >= ileD) {
            r.dodatkowe = { pula: pulaD, ile: ileD };
        }
        return r;
    }

    /** Liczby 1..pula, bez powtorzen, rosnaco — albo null przy zlym elemencie. */
    function normalizujListe(wej, pula) {
        if (!Array.isArray(wej)) { return null; }
        var out = [], byla = {};
        for (var i = 0; i < wej.length; i++) {
            var n = liczba(wej[i]);
            if (!calkowita(n) || n < 1 || n > pula) { return null; }
            if (!byla[n]) { byla[n] = true; out.push(n); }
        }
        return out.sort(rosnaco);
    }

    /** Waliduje zestaw wg regul gry. Pusta/nieobecna lista dodatkowa = brak liczb dodatkowych. */
    function normalizuj(r, liczby, dodatkowe) {
        if (!r) { return { ok: false, blad: 'gra' }; }
        var g = normalizujListe(liczby, r.pula);
        if (!g) { return { ok: false, blad: 'liczby' }; }
        if (r.ile.indexOf(g.length) < 0) { return { ok: false, blad: 'ile' }; }
        var d = [];
        if (dodatkowe !== undefined && dodatkowe !== null && !(Array.isArray(dodatkowe) && dodatkowe.length === 0)) {
            if (!r.dodatkowe) { return { ok: false, blad: 'dodatkowe' }; }
            d = normalizujListe(dodatkowe, r.dodatkowe.pula);
            if (!d || d.length !== r.dodatkowe.ile) { return { ok: false, blad: 'dodatkowe' }; }
        }
        return { ok: true, liczby: g, dodatkowe: d };
    }

    function sygnatura(z) { return z.numbers.join(',') + '|' + (z.extra || []).join(','); }

    /** Porownanie z losowaniem — czysta funkcja, 0 trafien to 0, nie brak danych. */
    function porownaj(z, wylosowane, wylosowaneDod) {
        var los = {}, losD = {};
        (Array.isArray(wylosowane) ? wylosowane : []).forEach(function (n) { los[liczba(n)] = true; });
        (Array.isArray(wylosowaneDod) ? wylosowaneDod : []).forEach(function (n) { losD[liczba(n)] = true; });
        var tr = z.numbers.filter(function (n) { return los[n] === true; });
        var trD = (z.extra || []).filter(function (n) { return losD[n] === true; });
        return { trafione: tr, trafioneDodatkowe: trD, glowne: tr.length, dodatkowe: trD.length };
    }

    function przedzial(n) {
        n = calkowita(n) ? n : 0;
        if (n <= 0) { return '0'; }
        if (n === 1) { return '1'; }
        if (n <= 5) { return '2-5'; }
        if (n <= 10) { return '6-10'; }
        return '11-20';
    }

    /* ── OSTATNIO WIDZIANE LOSOWANIE ────────────────────────────────────────
       ID losowania ze strony (data-losowanie = draw_system_id / legacy_id):
       dodatnia liczba calkowita, do 12 cyfr, bez zer wiodacych. Wszystko inne
       ("", "0", "abc", "12a", -5, 1.5) to brak ID -> null. */
    function idLosowania(v) {
        var s = typeof v === 'number' ? (calkowita(v) ? String(v) : '') : (typeof v === 'string' ? v.trim() : '');
        return /^[1-9][0-9]{0,11}$/.test(s) ? s : null;
    }
    /** Czysta decyzja dla jednej gry. `stan` = odczytany obiekt klucza
        (dowolnej jakosci), `idStrony` = data-losowanie. Zwraca
        { pokaz, zapisz, id }: pierwsza wizyta -> zapisz bez komunikatu; to samo
        ID -> nic; inne ID -> komunikat i zapis; bledne ID -> nic. */
    function ocenWidziane(stan, kod, idStrony) {
        var id = idLosowania(idStrony);
        if (!id) { return { pokaz: false, zapisz: false, id: null }; }
        var ok = stan && typeof stan === 'object' && !Array.isArray(stan) && Object.prototype.hasOwnProperty.call(stan, kod);
        var poprzednie = ok ? idLosowania(stan[kod]) : null;
        if (!poprzednie) { return { pokaz: false, zapisz: true, id: id }; }
        if (poprzednie === id) { return { pokaz: false, zapisz: false, id: id }; }
        return { pokaz: true, zapisz: true, id: id };
    }

    function czyLimitMiejsca(e) {
        return !!e && (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED' || e.code === 22 || e.code === 1014);
    }

    /* ── MAGAZYN ────────────────────────────────────────────────────────────
       opcje: { gry: [wpisy slownikGier], magazyn: obiekt Storage (testy),
                en: true/false (domyslne nazwy), dokument, teraz: () => Date } */
    function utworz(opcje) {
        opcje = opcje || {};
        var REG = {}, kolejnosc = [];
        (Array.isArray(opcje.gry) ? opcje.gry : []).forEach(function (p) {
            var r = reguly(p);
            if (r && !REG[r.kod]) { REG[r.kod] = r; kolejnosc.push(r.kod); }
        });
        var en = !!opcje.en;
        var dok = opcje.dokument || null;
        var teraz = typeof opcje.teraz === 'function' ? opcje.teraz : function () { return new Date(); };
        var licznik = 0, migracjaWykonana = false;

        function sklep() {
            try {
                var s = opcje.magazyn !== undefined ? opcje.magazyn : root.localStorage;
                return s && typeof s.getItem === 'function' && typeof s.setItem === 'function' ? s : null;
            } catch (e) { return null; }          // Safari prywatne, zablokowane ciasteczka
        }
        function noweId() {
            licznik++;
            return 'z' + teraz().getTime().toString(36) + '-' + licznik.toString(36) + '-' + Math.floor(Math.random() * 1296).toString(36);
        }
        function idPoprawne(id) { return (typeof id === 'string' || calkowita(id)) && /^[A-Za-z0-9_-]{1,64}$/.test(String(id)); }
        function nazwaDomyslna(i) { return (jst("moje_zestawy_js.45b0d5c70344")) + (i + 1); }
        function nazwa(n, i) {
            var t = typeof n === 'string' ? n.replace(/\s+/g, ' ').trim() : '';
            return (t || nazwaDomyslna(i)).slice(0, NAZWA_MAX);
        }
        function pusty() { return { version: WERSJA, games: {}, migratedV1: {} }; }

        /** Jeden rekord z dowolnego zrodla -> rekord v2 albo null. */
        function rekord(r, s, i, zrodlo) {
            if (!s || typeof s !== 'object') { return null; }
            var n = normalizuj(r, s.numbers, s.extra);
            if (!n.ok) { return null; }
            var o = {
                id: idPoprawne(s.id) ? String(s.id) : noweId(),
                name: nazwa(s.name, i),
                numbers: n.liczby,
                extra: n.dodatkowe,
                source: ZRODLA.indexOf(s.source) >= 0 ? s.source : zrodlo,
                created: typeof s.created === 'string' ? s.created.slice(0, 40) : ''
            };
            // Fala 6B: opcjonalna data ostatniej edycji (sortowanie w centrum).
            // Zapisywana tylko, gdy jest — stare rekordy zostaja bajt w bajt takie same.
            if (typeof s.updated === 'string' && s.updated) { o.updated = s.updated.slice(0, 40); }
            return o;
        }

        /** Lista gry po odczycie: poprawne rekordy, bez duplikatow i powtorzonych id, max 20. */
        function oczyscListe(r, lista) {
            var out = [], sig = {}, ids = {};
            (Array.isArray(lista) ? lista : []).forEach(function (s, i) {
                if (out.length >= LIMIT) { return; }
                var z = rekord(r, s, i, 'import');
                if (!z || sig[sygnatura(z)]) { return; }
                if (ids[z.id]) { z.id = noweId(); }
                sig[sygnatura(z)] = true; ids[z.id] = true;
                out.push(z);
            });
            return out;
        }

        function odczyt() {
            var s = sklep();
            if (!s) { return { stan: 'niedostepny', dane: pusty() }; }
            var surowe;
            try { surowe = s.getItem(KLUCZ); } catch (e) { return { stan: 'niedostepny', dane: pusty() }; }
            if (surowe === null || surowe === undefined) { return { stan: 'pusty', dane: pusty() }; }
            var d = null;
            try { d = JSON.parse(surowe); } catch (e) { d = null; }
            if (!d || typeof d !== 'object' || Array.isArray(d)) {
                // Uszkodzony zapis odkladamy obok (raz), zanim ktokolwiek go nadpisze.
                try { if (s.getItem(KLUCZ_USZKODZONY) === null) { s.setItem(KLUCZ_USZKODZONY, String(surowe).slice(0, 200000)); } } catch (e) { /* bez miejsca: trudno */ }
                return { stan: 'uszkodzony', dane: pusty() };
            }
            var dane = pusty();
            var gry = d.games && typeof d.games === 'object' && !Array.isArray(d.games) ? d.games : {};
            Object.keys(gry).forEach(function (kod) {
                // Gra nieznana tej stronie zostaje bez zmian — nie kasujemy cudzych danych.
                dane.games[kod] = REG[kod] ? oczyscListe(REG[kod], gry[kod]) : gry[kod];
            });
            var m = d.migratedV1 && typeof d.migratedV1 === 'object' ? d.migratedV1 : {};
            Object.keys(m).forEach(function (kod) { if (m[kod] === true) { dane.migratedV1[kod] = true; } });
            return { stan: 'ok', dane: dane };
        }

        /** Zapis + ponowny odczyt. null = sukces, inaczej kod bledu. */
        function zapis(dane) {
            var s = sklep();
            if (!s) { return 'niedostepny'; }
            var tekst = JSON.stringify(dane);
            try { s.setItem(KLUCZ, tekst); } catch (e) { return czyLimitMiejsca(e) ? 'miejsce' : 'zapis'; }
            try { if (s.getItem(KLUCZ) !== tekst) { return 'weryfikacja'; } } catch (e) { return 'weryfikacja'; }
            return null;
        }

        function oglos(kod, akcja) {
            var d = dok || root.document;
            if (!d || typeof d.dispatchEvent !== 'function' || typeof root.CustomEvent !== 'function') { return; }
            try { d.dispatchEvent(new root.CustomEvent(ZDARZENIE, { detail: { game: kod, action: akcja || 'change' } })); } catch (e) { /* stary silnik */ }
        }

        /* Migracja v1 -> v2. Idempotentna: gra ze znacznikiem nie jest czytana
           drugi raz, a zestaw o tej samej sygnaturze nie jest dopisywany. */
        function migruj() {
            migracjaWykonana = true;
            var s = sklep();
            if (!s) { return { ok: false, blad: 'niedostepny', przeniesione: {} }; }
            var w = odczyt();
            if (w.stan === 'niedostepny') { return { ok: false, blad: 'niedostepny', przeniesione: {} }; }
            var d = w.dane, zmiana = false, przeniesione = {};
            kolejnosc.forEach(function (kod) {
                if (d.migratedV1[kod]) { return; }
                var surowe;
                try { surowe = s.getItem(KLUCZ_V1 + kod); } catch (e) { return; }
                if (surowe === null || surowe === undefined) { return; }
                var stare = [];
                try { var o = JSON.parse(surowe); if (o && Array.isArray(o.sets)) { stare = o.sets; } } catch (e) { stare = []; }
                var lista = d.games[kod] || [], sig = {}, ids = {}, ile = 0;
                lista.forEach(function (z) { sig[sygnatura(z)] = true; ids[z.id] = true; });
                stare.forEach(function (st, i) {
                    if (lista.length >= LIMIT) { return; }
                    var z = rekord(REG[kod], st, i, 'analizator');
                    if (!z || sig[sygnatura(z)]) { return; }
                    if (ids[z.id]) { z.id = noweId(); }
                    sig[sygnatura(z)] = true; ids[z.id] = true;
                    lista.push(z); ile++;
                });
                d.games[kod] = lista;
                d.migratedV1[kod] = true;
                przeniesione[kod] = ile;
                zmiana = true;
            });
            if (!zmiana) { return { ok: true, przeniesione: {} }; }
            var b = zapis(d);
            if (b) { return { ok: false, blad: b, przeniesione: {} }; }
            Object.keys(przeniesione).forEach(function (kod) { oglos(kod, 'migrate'); });
            return { ok: true, przeniesione: przeniesione };
        }
        function przygotuj() { if (!migracjaWykonana) { migruj(); } }

        function lista(kod) {
            if (!REG[kod]) { return []; }
            przygotuj();
            return kopia(odczyt().dane.games[kod] || []);
        }

        /** Dopisuje zestawy jednym zapisem. zestawy: [{liczby, dodatkowe, nazwa}] */
        function dodajWiele(kod, zestawy, zrodlo) {
            var r = REG[kod];
            var wynik = { ok: false, blad: null, zapisane: 0, duplikaty: 0, ponadLimit: 0, bledne: 0, liczba: 0, dodane: [] };
            if (!r) { wynik.blad = 'gra'; return wynik; }
            przygotuj();
            var w = odczyt();
            if (w.stan === 'niedostepny') { wynik.blad = 'niedostepny'; return wynik; }
            var d = w.dane, obecna = d.games[kod] || [], sig = {};
            obecna.forEach(function (z) { sig[sygnatura(z)] = true; });
            var zr = ZRODLA.indexOf(zrodlo) >= 0 ? zrodlo : 'import';
            (Array.isArray(zestawy) ? zestawy : []).forEach(function (z) {
                var n = normalizuj(r, z && z.liczby, z && z.dodatkowe);
                if (!n.ok) { wynik.bledne++; return; }
                var nowy = { id: noweId(), name: nazwa(z.nazwa || krotkaNazwa(en, obecna.length, zr, teraz()), obecna.length), numbers: n.liczby, extra: n.dodatkowe, source: zr, created: teraz().toISOString() };
                if (sig[sygnatura(nowy)]) { wynik.duplikaty++; return; }
                if (obecna.length >= LIMIT) { wynik.ponadLimit++; return; }
                sig[sygnatura(nowy)] = true;
                obecna = obecna.concat([nowy]);
                wynik.dodane.push(kopia(nowy));
                wynik.zapisane++;
            });
            wynik.liczba = obecna.length;
            if (wynik.zapisane === 0) {
                wynik.ok = wynik.duplikaty > 0 && wynik.bledne === 0 && wynik.ponadLimit === 0;
                wynik.blad = wynik.ponadLimit > 0 ? 'limit' : (wynik.bledne > 0 ? 'niepoprawny' : (wynik.duplikaty > 0 ? 'duplikat' : 'pusto'));
                return wynik;
            }
            d.games[kod] = obecna;
            var b = zapis(d);
            if (b) { wynik.blad = b; wynik.zapisane = 0; wynik.dodane = []; wynik.liczba = (w.dane.games[kod] || []).length; return wynik; }
            wynik.ok = true;
            oglos(kod, zr === 'import' ? 'import' : 'add');
            return wynik;
        }

        function dodaj(kod, zestaw, zrodlo) {
            var w = dodajWiele(kod, [zestaw || {}], zrodlo);
            return { ok: w.zapisane === 1, blad: w.zapisane === 1 ? null : w.blad, zestaw: w.dodane[0] || null, liczba: w.liczba };
        }

        function zmien(kod, id, fn) {
            if (!REG[kod]) { return { ok: false, blad: 'gra' }; }
            przygotuj();
            var w = odczyt();
            if (w.stan === 'niedostepny') { return { ok: false, blad: 'niedostepny' }; }
            var d = w.dane, stara = d.games[kod] || [];
            var nowa = fn(stara);
            if (nowa === null) { return { ok: false, blad: 'brak' }; }
            d.games[kod] = nowa;
            var b = zapis(d);
            if (b) { return { ok: false, blad: b }; }
            oglos(kod, 'change');
            return { ok: true, liczba: nowa.length };
        }
        function usun(kod, id) {
            return zmien(kod, id, function (l) {
                var n = l.filter(function (z) { return z.id !== String(id); });
                return n.length === l.length ? null : n;
            });
        }
        function zmienNazwe(kod, id, nowaNazwa) {
            return zmien(kod, id, function (l) {
                var jest = false;
                var n = l.map(function (z, i) {
                    if (z.id !== String(id)) { return z; }
                    jest = true;
                    var c = kopia(z); c.name = nazwa(nowaNazwa, i); return c;
                });
                return jest ? n : null;
            });
        }

        /** Edycja w miejscu: nie zmienia id, daty utworzenia ani źródła; ustawia `updated`. */
        function edytuj(kod, id, pola) {
            var r = REG[kod];
            if (!r) { return { ok: false, blad: 'gra' }; }
            var n = normalizuj(r, pola && pola.liczby, pola && pola.dodatkowe);
            if (!n.ok) { return { ok: false, blad: n.blad }; }
            przygotuj();
            var w = odczyt();
            if (w.stan === 'niedostepny') { return { ok: false, blad: 'niedostepny' }; }
            var listaGry = w.dane.games[kod] || [];
            var indeks = listaGry.findIndex(function (z) { return z.id === String(id); });
            if (indeks < 0) { return { ok: false, blad: 'brak' }; }
            var aktualny = listaGry[indeks];
            var nowy = kopia(aktualny);
            nowy.name = nazwa(pola.nazwa, indeks);
            nowy.numbers = n.liczby;
            nowy.extra = n.dodatkowe;
            nowy.updated = teraz().toISOString();
            if (listaGry.some(function (z, i) { return i !== indeks && sygnatura(z) === sygnatura(nowy); })) {
                return { ok: false, blad: 'duplikat' };
            }
            w.dane.games[kod] = listaGry.map(function (z, i) { return i === indeks ? nowy : z; });
            var blad = zapis(w.dane);
            if (blad) { return { ok: false, blad: blad }; }
            oglos(kod, 'change');
            return { ok: true, zestaw: kopia(nowy), liczba: listaGry.length };
        }

        /** Eksport jednej gry: te same pola co v1 (game, pool, pick, sets) + extra. */
        function eksport(kod) {
            var r = REG[kod];
            if (!r) { return null; }
            var out = { version: WERSJA, game: kod, pool: r.pula, pick: r.pick, sets: lista(kod).map(function (z) {
                return { id: z.id, name: z.name, numbers: z.numbers, extra: z.extra };
            }) };
            if (r.dodatkowe) { out.extraPool = r.dodatkowe.pula; out.extraPick = r.dodatkowe.ile; }
            return out;
        }

        /** Import pliku v1 albo v2 tej samej gry. Laczy z zapisanymi (bez duplikatow). */
        function importuj(kod, obj) {
            var r = REG[kod];
            var zly = { ok: false, blad: 'format', zapisane: 0, duplikaty: 0, ponadLimit: 0, bledne: 0 };
            if (!r || !obj || typeof obj !== 'object' || obj.game !== kod || !Array.isArray(obj.sets)) { return zly; }
            if (obj.pool !== undefined && liczba(obj.pool) !== r.pula) { return zly; }
            if (obj.pick !== undefined && r.ile.indexOf(liczba(obj.pick)) < 0) { return zly; }
            var w = dodajWiele(kod, obj.sets.map(function (s) {
                return s && typeof s === 'object' ? { liczby: s.numbers, dodatkowe: s.extra, nazwa: s.name } : null;
            }), 'import');
            if (obj.sets.length > 0 && w.bledne === obj.sets.length) { return zly; }
            return w;
        }

        /* ── FALA 6A: kopia calego notatnika i ATOMOWY import ───────────────
           eksportWszystko() sklada pakiet z istniejacego eksport() kazdej gry.
           importujPlik() przyjmuje ten pakiet albo pojedynczy plik gry (v1/v2,
           ten sam ksztalt, co importuj()). Najpierw sprawdza CALY plik — wersje,
           kod gry, pule, liczby i limit — i dopiero potem robi JEDEN zapis.
           Blad w dowolnym zestawie albo przekroczony limit = nic nie zapisano.
           importuj() zostaje bez zmian (laczy czesciowo, jak w analizatorze). */
        function eksportWszystko() {
            var gry = [];
            kolejnosc.forEach(function (kod) { if (lista(kod).length) { gry.push(eksport(kod)); } });
            return { version: WERSJA, format: FORMAT_PAKIETU, games: gry };
        }
        function importujPlik(obj) {
            var wynik = { ok: false, blad: null, gra: null, zapisane: 0, duplikaty: 0, gry: {} };
            function stop(blad, kod) { wynik.blad = blad; wynik.gra = kod || null; wynik.zapisane = 0; wynik.duplikaty = 0; wynik.gry = {}; return wynik; }
            if (!obj || typeof obj !== 'object' || Array.isArray(obj)) { return stop('format'); }
            var pliki;
            if (obj.format === FORMAT_PAKIETU) {
                if (obj.version !== WERSJA) { return stop('wersja'); }
                if (!Array.isArray(obj.games)) { return stop('format'); }
                pliki = obj.games;
            } else if (typeof obj.game === 'string') {
                pliki = [obj];
            } else { return stop('format'); }
            if (pliki.length > kolejnosc.length) { return stop('format'); }
            przygotuj();
            var w = odczyt();
            if (w.stan === 'niedostepny') { return stop('niedostepny'); }
            var d = w.dane, byly = {}, zmienione = [];
            for (var p = 0; p < pliki.length; p++) {
                var f = pliki[p];
                if (!f || typeof f !== 'object' || Array.isArray(f)) { return stop('format'); }
                if (f.version !== undefined && f.version !== 1 && f.version !== 2) { return stop('wersja'); }
                var kod = typeof f.game === 'string' ? f.game : '', r = REG[kod];
                if (!r) { return stop('gra'); }
                if (byly[kod]) { return stop('format', kod); }
                byly[kod] = true;
                if (f.pool !== undefined && liczba(f.pool) !== r.pula) { return stop('format', kod); }
                if (f.pick !== undefined && r.ile.indexOf(liczba(f.pick)) < 0) { return stop('format', kod); }
                if (f.extraPool !== undefined && (!r.dodatkowe || liczba(f.extraPool) !== r.dodatkowe.pula)) { return stop('format', kod); }
                if (!Array.isArray(f.sets) || f.sets.length > IMPORT_MAX) { return stop('format', kod); }
                var obecna = (d.games[kod] || []).slice(), sig = {}, nowe = 0;
                obecna.forEach(function (z) { sig[sygnatura(z)] = true; });
                for (var i = 0; i < f.sets.length; i++) {
                    var s = f.sets[i];
                    if (!s || typeof s !== 'object' || Array.isArray(s)) { return stop('liczby', kod); }
                    var n = normalizuj(r, s.numbers, s.extra);
                    if (!n.ok) { return stop('liczby', kod); }
                    var z = { id: noweId(), name: nazwa(s.name, obecna.length), numbers: n.liczby, extra: n.dodatkowe, source: 'import', created: teraz().toISOString() };
                    if (sig[sygnatura(z)]) { wynik.duplikaty++; continue; }
                    sig[sygnatura(z)] = true;
                    obecna.push(z); nowe++;
                }
                if (obecna.length > LIMIT) { return stop('limit', kod); }
                if (nowe) { d.games[kod] = obecna; wynik.gry[kod] = nowe; wynik.zapisane += nowe; zmienione.push(kod); }
            }
            if (!wynik.zapisane) { wynik.ok = true; return wynik; }
            var b = zapis(d);
            if (b) { return stop(b); }
            zmienione.forEach(function (kod) { oglos(kod, 'import'); });
            wynik.ok = true;
            return wynik;
        }

        /** Cofniecie usuniecia: ten sam rekord (id, nazwa, data, zrodlo) wraca na
            swoje miejsce. Odmowa, gdy w miedzyczasie pojawil sie identyczny zestaw
            albo gra dobila do limitu (np. zapis z drugiej karty). */
        function przywroc(kod, zestaw, indeks) {
            var r = REG[kod];
            if (!r) { return { ok: false, blad: 'gra' }; }
            if (!zestaw || !idPoprawne(zestaw.id)) { return { ok: false, blad: 'niepoprawny' }; }
            var z = rekord(r, zestaw, 0, 'panel');
            if (!z) { return { ok: false, blad: 'niepoprawny' }; }
            przygotuj();
            var w = odczyt();
            if (w.stan === 'niedostepny') { return { ok: false, blad: 'niedostepny' }; }
            var l = (w.dane.games[kod] || []).slice();
            if (l.some(function (x) { return x.id === z.id || sygnatura(x) === sygnatura(z); })) { return { ok: false, blad: 'duplikat' }; }
            if (l.length >= LIMIT) { return { ok: false, blad: 'limit' }; }
            var i = calkowita(indeks) && indeks >= 0 && indeks <= l.length ? indeks : l.length;
            l.splice(i, 0, z);
            w.dane.games[kod] = l;
            var b = zapis(w.dane);
            if (b) { return { ok: false, blad: b }; }
            oglos(kod, 'restore');
            return { ok: true, zestaw: kopia(z), liczba: l.length };
        }

        /* Ostatnio widziane losowanie (klucz KLUCZ_WIDZIANE). Tylko dla gry,
           ktora ma zapisane zestawy. null = magazyn niedostepny (nic nie robic);
           uszkodzony albo obcy ksztalt = {} (jak pierwsza wizyta). */
        function odczytWidziane() {
            var s = sklep();
            if (!s) { return null; }
            var surowe;
            try { surowe = s.getItem(KLUCZ_WIDZIANE); } catch (e) { return null; }
            if (surowe === null || surowe === undefined) { return {}; }
            try {
                var o = JSON.parse(surowe);
                return o && typeof o === 'object' && !Array.isArray(o) ? o : {};
            } catch (e) { return {}; }
        }
        var NIC = { pokaz: false, zapisz: false, id: null };
        function widziane(kod, idStrony) {
            if (!REG[kod] || !lista(kod).length) { return kopia(NIC); }
            var stan = odczytWidziane();
            return stan === null ? kopia(NIC) : ocenWidziane(stan, kod, idStrony);
        }
        /** Strona glowna (Fala 3): tylko ODCZYT. Prawda, gdy zapisane ID jest
            poprawne, a ID ze strony jest od niego WIEKSZE. Scisle „wieksze”, nie
            „inne”: glowna czyta ID z indeksu gier, ktory moze chwile odstawac od
            last.json strony wynikow — starsze ID nie moze zapalac „nowego wyniku”. */
        function nowszeNizWidziane(kod, idStrony) {
            var id = idLosowania(idStrony);
            if (!REG[kod] || !id || !lista(kod).length) { return false; }
            var stan = odczytWidziane();
            var poprzednie = stan && Object.prototype.hasOwnProperty.call(stan, kod) ? idLosowania(stan[kod]) : null;
            return !!poprzednie && Number(id) > Number(poprzednie);
        }
        /** Zapis ID jako widzianego. Przepisuje tylko poprawne pary gra -> ID
            znanych gier, wiec w kluczu nigdy nie zostaje nic poza ID. */
        function zapiszWidziane(kod, idStrony) {
            var id = idLosowania(idStrony), s = sklep();
            if (!REG[kod] || !id || !s || !lista(kod).length) { return false; }
            var stan = odczytWidziane();
            if (stan === null) { return false; }
            var czyste = {};
            kolejnosc.forEach(function (k) {
                var v = Object.prototype.hasOwnProperty.call(stan, k) ? idLosowania(stan[k]) : null;
                if (v) { czyste[k] = v; }
            });
            czyste[kod] = id;
            try { s.setItem(KLUCZ_WIDZIANE, JSON.stringify(czyste)); } catch (e) { return false; }
            return true;
        }

        /** GA4 przez istniejacy gtag (Consent Mode v2 z layout/_zgoda.html.twig).
            Wylacznie: nazwa z listy, kod gry, zrodlo widoku, przedzial liczby zestawow
            oraz jawnie dozwolone parametry interfejsu. Nigdy liczby, nazwy ani ID kuponu. */
        function zdarzenie(nazwaZd, kod, zrodlo, ile, detale) {
            if (ZDARZENIA_GA4.indexOf(nazwaZd) < 0 || !REG[kod] || ZRODLA_GA4.indexOf(zrodlo) < 0) { return false; }
            var g = root.gtag;
            if (typeof g !== 'function') { return false; }
            var dane = { game: kod, source: zrodlo, sets_range: przedzial(ile) };
            if (detale && typeof detale === 'object') {
                if (ZAKRESY_GA4.indexOf(String(detale.range)) >= 0) { dane.range_window = String(detale.range); }
                if (TRYBY_GA4.indexOf(String(detale.mode)) >= 0) { dane.action_mode = String(detale.mode); }
                if (calkowita(detale.generated)) { dane.generated_sets_range = przedzial(detale.generated); }
            }
            try { g('event', nazwaZd, dane); return true; } catch (e) { return false; }
        }

        return {
            KLUCZ: KLUCZ, LIMIT: LIMIT,
            gry: function () { return kolejnosc.slice(); },
            reguly: function (kod) { return REG[kod] ? kopia(REG[kod]) : null; },
            dostepny: function () { return odczyt().stan !== 'niedostepny'; },
            stan: function () { return odczyt().stan; },
            lista: lista, dodaj: dodaj, dodajWiele: dodajWiele, usun: usun, zmienNazwe: zmienNazwe, edytuj: edytuj,
            eksport: eksport, importuj: importuj, migruj: migruj, zdarzenie: zdarzenie,
            eksportWszystko: eksportWszystko, importujPlik: importujPlik, przywroc: przywroc,
            widziane: widziane, zapiszWidziane: zapiszWidziane, nowszeNizWidziane: nowszeNizWidziane,
            porownaj: porownaj, normalizuj: function (kod, l, d) { return normalizuj(REG[kod], l, d); }
        };
    }

    /* ── FALA 6A: JEDNORAZOWE PRZEKAZANIE ZESTAWU DO NARZEDZIA ─────────────
       Panel zapisuje w sessionStorage WYLACZNIE {cel, gra, id, t} — bez liczb
       i nazwy — i przechodzi do zwyklego adresu narzedzia (?gra=kod). Strona
       docelowa odbiera wpis RAZ (odczyt = usuniecie), bierze zestaw po id
       z localStorage i tylko wypelnia pola. Wpis starszy niz 10 min, z przyszlosci
       albo w obcym ksztalcie jest ignorowany. `sesja` = obiekt Storage (testy). */
    function magazynSesji(sesja) {
        try {
            var s = sesja !== undefined ? sesja : root.sessionStorage;
            return s && typeof s.getItem === 'function' && typeof s.setItem === 'function' ? s : null;
        } catch (e) { return null; }
    }
    function zapiszPrzekaz(cel, kod, id, sesja, teraz) {
        var s = magazynSesji(sesja);
        if (!s || CELE_PRZEKAZU.indexOf(cel) < 0 || typeof kod !== 'string' || !/^[a-z][a-z0-9-]{0,30}$/.test(kod) || !/^[A-Za-z0-9_-]{1,64}$/.test(String(id))) { return false; }
        try { s.setItem(KLUCZ_PRZEKAZ, JSON.stringify({ v: 1, cel: cel, gra: kod, id: String(id), t: (teraz || Date.now)() })); return true; } catch (e) { return false; }
    }
    function odbierzPrzekaz(sesja, teraz) {
        var s = magazynSesji(sesja), surowe = null;
        if (!s) { return null; }
        try { surowe = s.getItem(KLUCZ_PRZEKAZ); } catch (e) { return null; }
        if (surowe === null || surowe === undefined) { return null; }
        try { if (typeof s.removeItem === 'function') { s.removeItem(KLUCZ_PRZEKAZ); } } catch (e) { /* trudno */ }
        var o = null;
        try { o = JSON.parse(surowe); } catch (e) { return null; }
        var t = (teraz || Date.now)();
        if (!o || typeof o !== 'object' || o.v !== 1 || CELE_PRZEKAZU.indexOf(o.cel) < 0 || typeof o.gra !== 'string' || !/^[a-z][a-z0-9-]{0,30}$/.test(o.gra) ||
            typeof o.id !== 'string' || !/^[A-Za-z0-9_-]{1,64}$/.test(o.id) || !calkowita(o.t) || o.t > t + 60000 || t - o.t > PRZEKAZ_MS) { return null; }
        return { cel: o.cel, gra: o.gra, id: o.id };
    }
    /** „Urodziny” -> „Urodziny (kopia)”, a gdy juz jest -> „Urodziny (kopia 2)”… Max 60 znakow. */
    function nazwaKopii(en, nazwaZrodla, zajete) {
        var slowo = jst("moje_zestawy_js.d7efaea5fe33", [], en ? 'en' : 'pl');
        var baza = String(nazwaZrodla || '').replace(/\s+/g, ' ').trim().replace(/\s\((?:kopia|copy)(?: \d+)?\)$/, '') || jst("moje_zestawy_js.11635d3960bd", [], en ? 'en' : 'pl');
        var jest = {};
        (zajete || []).forEach(function (n) { jest[n] = true; });
        for (var i = 1; i <= LIMIT + 1; i++) {
            var dopisek = ' (' + slowo + (i > 1 ? ' ' + i : '') + ')';
            var kandydat = baza.slice(0, NAZWA_MAX - dopisek.length).trim() + dopisek;
            if (!jest[kandydat]) { return kandydat; }
        }
        return baza.slice(0, NAZWA_MAX);
    }
    var przekazStrony = null;
    /** Odbior przekazania przez widok: tylko pasujacy cel i gra, tylko raz. */
    function wezPrzekaz(cel, kod) {
        var p = przekazStrony;
        if (!p || p.cel !== cel || (kod && p.gra !== kod)) { return null; }
        przekazStrony = null;
        return p;
    }

    /* ── WIDOKI ──────────────────────────────────────────────────────────── */

    function jezykInterfejsu(en) {
        var doc = root.document;
        var skrot = doc && doc.querySelector ? doc.querySelector('[data-mk-skrot]') : null;
        var jezyk = skrot && skrot.getAttribute ? skrot.getAttribute('data-mk-lang') : '';
        if (!jezyk && doc && doc.documentElement) { jezyk = doc.documentElement.lang || ''; }
        jezyk = String(jezyk || (en ? 'en' : 'pl')).toLowerCase().split('-')[0];
        return ['pl', 'en', 'de', 'nl', 'es'].indexOf(jezyk) >= 0 ? jezyk : (en ? 'en' : 'pl');
    }
    function daneJezykowe(en) {
        var doc = root.document, el = doc && doc.getElementById ? doc.getElementById('moje-kupony-ui-json') : null;
        if (el) { try { var dane = JSON.parse(el.textContent || '{}'); return dane && typeof dane === 'object' ? dane : {}; } catch (e) { return {}; } }
        if (typeof module === 'object' && module && module.exports && typeof require === 'function') {
            try { return require('../json/i18n/' + jezykInterfejsu(en) + '/moje-kupony-ui.json'); } catch (e) { return {}; }
        }
        return {};
    }
    function komunikatJezykowy(grupa, en, klucz, args) {
        var dane = daneJezykowe(en)[grupa] || {}, jezyk = jezykInterfejsu(en);
        var slownik = dane[jezyk] || dane[en ? 'en' : 'pl'] || dane.en || dane.pl || {};
        var t = typeof slownik[klucz] === 'string' ? slownik[klucz] : '';
        return t.replace(/%([1-4])/g, function (_, n) { var v = args[Number(n) - 1]; return v === undefined ? '' : String(v); });
    }
    function tekst(en, klucz, a, b, c, d) {
        return komunikatJezykowy('js_text', en, klucz, [a, b, c, d]);
    }
    /** „1 zestaw”, „2 zestawy”, „5 zestawów”, „12 zestawów”, „22 zestawy”. */
    function liczbaZestawow(en, n) {
        var d = n % 10, s = n % 100;
        var k = n === 1 ? 'zestawy1' : (d >= 2 && d <= 4 && (s < 12 || s > 14) ? 'zestawy2' : 'zestawy5');
        return tekst(en, k, n);
    }
    function el(doc, tag, klasa, tresc) {
        var x = doc.createElement(tag);
        if (klasa) { x.className = klasa; }
        if (tresc !== undefined) { x.textContent = tresc; }
        return x;
    }
    function oznaczenieGry(doc, kod) {
        var skroty = { lotto: 'dl', 'lotto-plus': 'dp', eurojackpot: 'ej', 'mini-lotto': 'el', 'multi-multi': 'ml', kaskada: 'kl', keno: 'ke' };
        if (!Object.prototype.hasOwnProperty.call(skroty, kod)) { return null; }
        var badge = el(doc, 'span', 'skrot-gry skrot-gry--' + kod);
        badge.setAttribute('data-skrot', skroty[kod]);
        badge.setAttribute('aria-hidden', 'true');
        return badge;
    }
    function nazwaZGra(doc, element, kod, nazwa) {
        var badge = oznaczenieGry(doc, kod);
        element.textContent = '';
        if (badge) { element.appendChild(badge); element.appendChild(doc.createTextNode(' ')); }
        element.appendChild(doc.createTextNode(nazwa));
        return element;
    }
    var IKONY_AKCJI = {
        wczytaj: ['M12 3v12M7 10l5 5 5-5', 'M5 20h14'],
        edytuj: ['M4 20h4l11-11a2.1 2.1 0 0 0-4-4L4 16v4Z', 'm13.5 6.5 4 4'],
        dokument: ['M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z', 'M14 3v5h5', 'M9 13h6M9 17h6'],
        usun: ['M18 6 6 18M6 6l12 12'],
        zamkniete: ['M18 6 6 18M6 6l12 12']
    };
    function ikonaAkcji(doc, nazwa) {
        var svg = doc.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('class', 'ikona');
        svg.setAttribute('data-ikona', nazwa);
        svg.setAttribute('width', '18'); svg.setAttribute('height', '18');
        svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('fill', 'none');
        svg.setAttribute('stroke', 'currentColor'); svg.setAttribute('stroke-width', '2');
        svg.setAttribute('stroke-linecap', 'round'); svg.setAttribute('stroke-linejoin', 'round');
        svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
        (IKONY_AKCJI[nazwa] || IKONY_AKCJI.dokument).forEach(function (d) {
            var path = doc.createElementNS('http://www.w3.org/2000/svg', 'path');
            path.setAttribute('d', d); svg.appendChild(path);
        });
        return svg;
    }
    function przyciskAkcji(doc, klasa, tresc, ikona) {
        var x = el(doc, 'button', klasa + ' kupon-akcja');
        x.appendChild(ikonaAkcji(doc, ikona));
        var etykieta = el(doc, 'span', '', tresc);
        etykieta.setAttribute('data-przycisk-tekst', '');
        x.appendChild(etykieta);
        return x;
    }
    function ustawEtykieteAkcji(przycisk, tresc) {
        if (!przycisk) { return; }
        var etykieta = przycisk.querySelector('[data-przycisk-tekst]');
        if (etykieta) { etykieta.textContent = tresc; }
        else { przycisk.textContent = tresc; }
    }
    function wyczysc(w) { while (w.firstChild) { w.removeChild(w.firstChild); } }

    /** Kule zestawu. Trafienie ma klase `kula--trafiona` ORAZ jest w opisie
        tekstowym obok, bo kolor nie moze byc jedynym sygnalem. Trafiona kula
        NIE dostaje koloru gry: `.kula--<gra>` stoi w build.css po
        `.kula--trafiona` i przykrywal jej tlo (zmierzone 24.09.2026). */
    function kule(doc, en, kod, z, wynik) {
        var box = el(doc, 'span', "kule kule--inline");
        var opis = [tekst(en, 'liczbyAria', z.numbers.join(', '))];
        if (z.extra && z.extra.length) { opis.push(tekst(en, 'dodatkoweAria', z.extra.join(', '))); }
        if (wynik) {
            var tr = wynik.trafione.concat(wynik.trafioneDodatkowe);
            opis.push(tr.length ? tekst(en, 'trafioneAria', tr.join(', ')) : tekst(en, 'brakTrafien'));
        }
        box.setAttribute('role', 'img');
        box.setAttribute('aria-label', opis.join('; '));
        z.numbers.forEach(function (n) {
            var traf = wynik && wynik.trafione.indexOf(n) >= 0;
            var k = el(doc, 'span', "kula kula--mala " + (traf ? 'kula--trafiona' : 'kula--' + kod), String(n));
            k.setAttribute('aria-hidden', 'true');
            box.appendChild(k);
        });
        (z.extra || []).forEach(function (n) {
            var traf = wynik && wynik.trafioneDodatkowe.indexOf(n) >= 0;
            var k = el(doc, 'span', "kula kula--mala " + (traf ? 'kula--trafiona' : 'kula--specjalna'), String(n));
            k.setAttribute('aria-hidden', 'true');
            box.appendChild(k);
        });
        return box;
    }

    /** Lista zestawow: <ul> z nazwa, kulami i opcjonalnym dodatkiem na wiersz. */
    function listaZestawow(doc, en, kod, zestawy, dodatek) {
        var ul = el(doc, 'ul', 'lista-linkow');
        ul.setAttribute('role', 'list');
        zestawy.forEach(function (z) {
            var li = el(doc, 'li', jst("ui.9e71d4bba681c313"));
            li.dataset.mzId = z.id;
            li.appendChild(el(doc, 'strong', '', z.name));
            dodatek(li, z);
            ul.appendChild(li);
        });
        return ul;
    }

    function komunikatZapisu(en, w, r) {
        if (w.zapisane > 0) {
            var t = tekst(en, 'zapisano', w.zapisane, w.liczba, LIMIT);
            if (w.duplikaty) { t += ' ' + tekst(en, 'duplikaty', w.duplikaty); }
            if (w.ponadLimit) { t += ' ' + tekst(en, 'limit', LIMIT, w.ponadLimit); }
            return { t: t, zly: false };
        }
        if (w.blad === 'limit') { return { t: tekst(en, 'limit', LIMIT, w.ponadLimit), zly: true }; }
        if (w.blad === 'duplikat') { return { t: tekst(en, 'juzZapisane'), zly: false }; }
        if (w.blad === 'niedostepny') { return { t: tekst(en, 'niedostepny'), zly: true }; }
        if (w.blad === 'miejsce') { return { t: tekst(en, 'miejsce'), zly: true }; }
        return { t: tekst(en, 'bladZapisu'), zly: true };
    }

    /* Generator: jawne „Zapisz" — nigdy autozapis. Generator (inline w
       generator.html.twig) podaje ostatnio wylosowane zestawy przez
       wlasciwosc `mzOstatnie` i zdarzenie `pewniaki:wygenerowano`. */
    function widokGenerator(doc, S, en, box) {
        var gen = doc.querySelector('[data-gen]');
        var przycisk = gen ? gen.querySelector('[data-mz-zapisz]') : null;
        var status = box.querySelector('[data-mz-status]');
        var link = box.querySelector('[data-mz-link-sprawdz]');
        if (!gen || !przycisk || !status) { return; }
        var baza = link ? link.getAttribute('href').split('?')[0] : '';
        function aktywna() {
            var b = doc.querySelector('[data-pasek-gier] .kupon-gra[aria-pressed="true"]');
            return b ? b.getAttribute('data-gra') : null;
        }
        function odswiez(zdarzenieMagazynu) {
            var o = gen.mzOstatnie;
            // `disabled`, nie `hidden`: .przycisk ma display:inline-flex, ktore
            // wygrywa z regula [hidden] z preflightu.
            przycisk.disabled = !(o && o.zestawy && o.zestawy.length);
            var kod = (o && o.gra) || aktywna();
            if (link && baza && kod) { link.setAttribute('href', baza + '?gra=' + encodeURIComponent(kod)); }
            // Fala 3: bez zadnego zapisu link „sprawdz zapisane” prowadzil do
            // pustej listy. W stanie pustym nastepnym krokiem jest przycisk
            // „Zapisz” obok; link wraca po pierwszym zapisie.
            if (link) { link.hidden = !S.gry().some(function (k) { return S.lista(k).length > 0; }); }
        }
        gen.addEventListener('pewniaki:wygenerowano', function () { status.textContent = ''; odswiez(); });
        przycisk.addEventListener('click', function () {
            var o = gen.mzOstatnie;
            if (!o || !o.zestawy || !o.zestawy.length) { status.textContent = tekst(en, 'brakZestawow'); return; }
            var r = S.reguly(o.gra);
            var w = S.dodajWiele(o.gra, o.zestawy.map(function (z) {
                return { liczby: z.liczby, dodatkowe: r && r.dodatkowe ? z.dodatkowe : [] };
            }), 'generator');
            var k = komunikatZapisu(en, w, r);
            status.textContent = k.t;
            if (w.zapisane > 0) { S.zdarzenie('my_ticket_save', o.gra, 'generator', w.liczba); }
            odswiez();
        });
        doc.addEventListener(ZDARZENIE, odswiez);
        odswiez();
    }

    /* Sprawdzarka: lista zapisanych zestawow aktywnej gry + wczytanie jednego
       do ISTNIEJACEJ siatki. Wczytanie klika te same przyciski co czlowiek,
       wiec limity, aria-pressed i liczenie wygranych zostaja w sprawdzarce. */
    function widokSprawdzarka(doc, S, en, box) {
        var korzen = doc.getElementById('kupon');
        var miejsce = box.querySelector('[data-mz-lista]');
        var status = box.querySelector('[data-mz-status]');
        var statusAkcji = doc.querySelector('[data-mz-akcja-status]');
        var zapiszBiezacy = doc.querySelector('[data-mz-zapisz-biezacy]');
        var anulujEdycje = doc.querySelector('[data-mz-anuluj-edycje]');
        var pusto = box.querySelector('[data-mz-pusto]');
        var linkGenerator = pusto ? pusto.querySelector('a[href]') : null;
        var adresGenerator = linkGenerator ? linkGenerator.getAttribute('href').split('?')[0] : '';
        var wskazowka = box.querySelector('[data-mz-wskazowka]');
        var nazwaGry = box.querySelector('[data-mz-gra]');
        var raporty = {}, skrot = doc.querySelector('[data-mk-skrot]');
        try { raporty = JSON.parse(skrot ? (skrot.getAttribute('data-mk-raporty') || '{}') : '{}'); } catch (e) { raporty = {}; }
        if (!korzen || !miejsce || !status) { return; }
        var otwarte = {};
        var edytowany = null;
        var doUsuniecia = null;
        function aktywnyPrzycisk() { return korzen.querySelector('.kupon-gra[aria-pressed="true"]'); }
        function zakonczEdycje(czyscStatus) {
            edytowany = null;
            if (zapiszBiezacy) { ustawEtykieteAkcji(zapiszBiezacy, tekst(en, 'dodajBiezacy')); zapiszBiezacy.removeAttribute('data-mz-edytuje'); }
            if (anulujEdycje) { anulujEdycje.hidden = true; anulujEdycje.classList.add('hidden'); }
            if (czyscStatus && statusAkcji) { statusAkcji.textContent = ''; }
        }
        function rysuj() {
            var p = aktywnyPrzycisk(), kod = p ? p.getAttribute('data-gra') : null;
            wyczysc(miejsce);
            if (!kod) { return; }
            var r = S.reguly(kod), zestawy = S.lista(kod);
            box.setAttribute('data-mz-empty', zestawy.length ? '0' : '1');
            if (wskazowka) { wskazowka.hidden = zestawy.length === 0; }
            if (nazwaGry) { nazwaZGra(doc, nazwaGry, kod, r ? r.nazwa : ''); }
            if (linkGenerator && adresGenerator) { linkGenerator.setAttribute('href', adresGenerator + '?gra=' + encodeURIComponent(kod)); }
            if (pusto) {
                pusto.hidden = zestawy.length > 0;
                var t = pusto.querySelector('[data-mz-pusto-tekst]');
                if (t) { t.textContent = tekst(en, 'pusto', r ? r.nazwa : kod); }
            }
            if (!zestawy.length) { return; }
            miejsce.appendChild(listaZestawow(doc, en, kod, zestawy, function (li, z) {
                li.appendChild(kule(doc, en, kod, z, null));
                var b = przyciskAkcji(doc, "przycisk przycisk--drugi", tekst(en, 'wczytaj'), 'wczytaj');
                b.type = 'button';
                b.dataset.mzWczytaj = z.id;
                b.setAttribute('aria-label', tekst(en, 'wczytajAria', z.name));
                li.appendChild(b);
                var e = przyciskAkcji(doc, "przycisk przycisk--drugi", tekst(en, 'edytuj'), 'edytuj');
                e.type = 'button';
                e.dataset.mzEdytuj = z.id;
                e.setAttribute('aria-label', tekst(en, 'edytujAria', z.name));
                li.appendChild(e);
                if (raporty[kod]) {
                    var raport = przyciskAkcji(doc, "przycisk przycisk--drugi", jst("moje_zestawy_js.da256b458dc3"), 'dokument');
                    raport.type = 'button'; raport.dataset.mzRaport = z.id;
                    raport.setAttribute('aria-label', en ? jst("ui.3a8c9aed5da755a7") + z.name + '”' : jst("moje_zestawy_js.literal.aeda32360fd3") + z.name + '”');
                    li.appendChild(raport);
                }
                var u = przyciskAkcji(doc, "przycisk przycisk--drugi", tekst(en, 'usunSprawdzarka'), 'usun');
                u.type = 'button';
                u.dataset.mzUsun = z.id;
                u.setAttribute('aria-label', tekst(en, 'usunSprawdzarkaAria', z.name));
                li.appendChild(u);
                if (doUsuniecia === z.id) {
                    var potwierdzenie = el(doc, 'span', jst("ui.9e71d4bba681c313"));
                    potwierdzenie.appendChild(el(doc, 'span', '', tekst(en, 'usunPytanie', z.name)));
                    var tak = przyciskAkcji(doc, "przycisk przycisk--drugi", tekst(en, 'usunTak'), 'usun');
                    tak.type = 'button'; tak.dataset.mzUsunTak = z.id;
                    potwierdzenie.appendChild(tak);
                    var nie = przyciskAkcji(doc, "przycisk przycisk--drugi", tekst(en, 'usunNie'), 'zamkniete');
                    nie.type = 'button'; nie.dataset.mzUsunNie = z.id;
                    potwierdzenie.appendChild(nie);
                    li.appendChild(potwierdzenie);
                }
            }));
            if (!otwarte[kod]) { otwarte[kod] = true; S.zdarzenie('my_ticket_open', kod, 'sprawdzarka', zestawy.length); }
        }
        function kliknijLiczby(siatka, liczby) {
            if (!siatka) { return 0; }
            var przyciski = siatka.querySelectorAll('.kupon-liczba'), ile = 0;
            liczby.forEach(function (n) {
                for (var i = 0; i < przyciski.length; i++) {
                    if (przyciski[i].textContent === String(n)) {
                        if (przyciski[i].getAttribute('aria-pressed') !== 'true') { przyciski[i].click(); }
                        if (przyciski[i].getAttribute('aria-pressed') === 'true') { ile++; }
                        return;
                    }
                }
            });
            return ile;
        }
        function wczytaj(id, dlaEdycji) {
            var p = aktywnyPrzycisk(), kod = p ? p.getAttribute('data-gra') : null;
            var r = S.reguly(kod), zestawy = S.lista(kod), z = null;
            zestawy.forEach(function (x) { if (x.id === id) { z = x; } });
            if (!z || !r) { return false; }
            if (z.numbers.length > r.kupon) {
                status.textContent = tekst(en, 'zaDuzo', z.name, z.numbers.length, r.nazwa, r.kupon);
                return false;
            }
            if (!dlaEdycji) { zakonczEdycje(false); }
            var wyczyscBtn = doc.getElementById('kupon-wyczysc');
            if (wyczyscBtn) { wyczyscBtn.click(); }
            var ok = kliknijLiczby(doc.getElementById('kupon-siatka'), z.numbers) === z.numbers.length;
            var blokD = doc.getElementById('kupon-spec-blok');
            if (ok && z.extra.length && blokD && !blokD.hidden) {
                ok = kliknijLiczby(doc.getElementById('kupon-siatka-spec'), z.extra) === z.extra.length;
            }
            status.textContent = ok ? tekst(en, 'wczytano', z.name) : tekst(en, 'nieWczytano');
            if (ok) { S.zdarzenie('my_ticket_load', kod, 'sprawdzarka', zestawy.length); }
            return ok;
        }
        function edytujWSiatce(id, przycisk) {
            var p = aktywnyPrzycisk(), kod = p ? p.getAttribute('data-gra') : null;
            var z = S.lista(kod).filter(function (x) { return x.id === id; })[0];
            if (!z || !wczytaj(id, true)) { return; }
            edytowany = { kod: kod, id: z.id, nazwa: z.name };
            if (zapiszBiezacy) { ustawEtykieteAkcji(zapiszBiezacy, tekst(en, 'zapiszZmiany')); }
            if (anulujEdycje) { anulujEdycje.hidden = false; anulujEdycje.classList.remove('hidden'); }
            if (statusAkcji) { statusAkcji.textContent = tekst(en, 'edycjaStart', z.name); }
            if (zapiszBiezacy) { zapiszBiezacy.setAttribute('data-mz-edytuje', z.id); }
            if (przycisk) { przycisk.setAttribute('aria-pressed', 'true'); }
        }
        function liczbyZSiatki(id) {
            return Array.prototype.map.call(doc.querySelectorAll(id + ' .kupon-liczba[aria-pressed="true"]'), function (b) {
                return parseInt(b.textContent, 10);
            }).filter(function (n) { return Number.isFinite(n); }).sort(rosnaco);
        }
        function zapiszWybrane() {
            var p = aktywnyPrzycisk(), kod = p ? p.getAttribute('data-gra') : null;
            var r = S.reguly(kod);
            if (!r) { return; }
            var glowne = liczbyZSiatki('#kupon-siatka');
            var dodatkowe = liczbyZSiatki('#kupon-siatka-spec');
            var n = S.normalizuj(kod, glowne, dodatkowe);
            var pelneDodatkowe = !r.dodatkowe || dodatkowe.length === r.dodatkowe.ile;
            if (!n.ok || !pelneDodatkowe) {
                if (statusAkcji) { statusAkcji.textContent = tekst(en, 'wybierzPelny', r.nazwa); }
                return;
            }
            var nazwa = edytowany && edytowany.kod === kod ? edytowany.nazwa : '';
            var w = edytowany && edytowany.kod === kod
                ? S.edytuj(kod, edytowany.id, { nazwa: nazwa, liczby: glowne, dodatkowe: dodatkowe })
                : S.dodaj(kod, { liczby: glowne, dodatkowe: dodatkowe }, 'sprawdzarka');
            if (!w.ok) {
                var k = komunikatZapisu(en, { zapisane: 0, liczba: w.liczba || S.lista(kod).length, duplikaty: w.blad === 'duplikat' ? 1 : 0, ponadLimit: w.blad === 'limit' ? 1 : 0, blad: w.blad }, r);
                if (statusAkcji) { statusAkcji.textContent = k.t; }
                return;
            }
            if (statusAkcji) {
                statusAkcji.textContent = edytowany ? tekst(en, 'zmianyZapisane', nazwa) : komunikatZapisu(en, { zapisane: 1, liczba: w.liczba, duplikaty: 0, ponadLimit: 0 }, r).t;
            }
            S.zdarzenie('my_ticket_save', kod, 'sprawdzarka', w.liczba);
            zakonczEdycje(false);
        }
        miejsce.addEventListener('click', function (e) {
            var b = e.target && e.target.closest ? e.target.closest('[data-mz-wczytaj]') : null;
            if (b) { wczytaj(b.dataset.mzWczytaj, false); return; }
            var ed = e.target && e.target.closest ? e.target.closest('[data-mz-edytuj]') : null;
            if (ed) { edytujWSiatce(ed.dataset.mzEdytuj, ed); return; }
            var raport = e.target && e.target.closest ? e.target.closest('[data-mz-raport]') : null;
            if (raport) {
                var aktywnaGra = aktywnyPrzycisk(), kodRaportu = aktywnaGra ? aktywnaGra.getAttribute('data-gra') : '';
                if (raporty[kodRaportu]) { zapiszPrzekaz('raport', kodRaportu, raport.dataset.mzRaport); root.location.assign(raporty[kodRaportu]); }
                return;
            }
            var u = e.target && e.target.closest ? e.target.closest('[data-mz-usun]') : null;
            if (u) {
                doUsuniecia = u.dataset.mzUsun; rysuj();
                var nie = miejsce.querySelector('[data-mz-usun-nie]');
                if (nie) { nie.focus(); }
                return;
            }
            var nie = e.target && e.target.closest ? e.target.closest('[data-mz-usun-nie]') : null;
            if (nie) {
                var id = nie.dataset.mzUsunNie;
                doUsuniecia = null; rysuj();
                var uPo = Array.prototype.filter.call(miejsce.querySelectorAll('[data-mz-usun]'), function (b) { return b.dataset.mzUsun === id; })[0];
                if (uPo) { uPo.focus(); }
                return;
            }
            var tak = e.target && e.target.closest ? e.target.closest('[data-mz-usun-tak]') : null;
            if (tak && doUsuniecia === tak.dataset.mzUsunTak) {
                var p = aktywnyPrzycisk(), kod = p ? p.getAttribute('data-gra') : null;
                var id = doUsuniecia;
                var z = S.lista(kod).filter(function (x) { return x.id === id; })[0];
                doUsuniecia = null;
                if (!z) { status.textContent = tekst(en, 'przekazBrak'); rysuj(); return; }
                var wynik = S.usun(kod, id);
                if (!wynik.ok) { status.textContent = wynik.blad === 'niedostepny' ? tekst(en, 'niedostepny') : tekst(en, 'bladZapisu'); rysuj(); return; }
                if (edytowany && edytowany.id === id && edytowany.kod === kod) { zakonczEdycje(true); }
                status.textContent = tekst(en, 'usunietoSprawdzarka', z.name);
                rysuj();
                var nastepny = miejsce.querySelector('[data-mz-wczytaj]');
                if (nastepny) { nastepny.focus(); }
            }
        });
        if (zapiszBiezacy) { zapiszBiezacy.addEventListener('click', zapiszWybrane); }
        if (anulujEdycje) { anulujEdycje.addEventListener('click', function () {
            zakonczEdycje(true);
            var wyczyscBtn = doc.getElementById('kupon-wyczysc');
            if (wyczyscBtn) { wyczyscBtn.click(); }
            if (zapiszBiezacy) { zapiszBiezacy.focus(); }
        }); }
        // Zmiana gry: wlasny sluchacz sprawdzarki na przycisku dziala pierwszy,
        // ten na pasku widzi juz nowe aria-pressed.
        var pasek = korzen.querySelector('[data-pasek-gier]');
        if (pasek) { pasek.addEventListener('click', function () { status.textContent = ''; doUsuniecia = null; zakonczEdycje(true); rysuj(); }); }
        doc.addEventListener(ZDARZENIE, rysuj);
        box.hidden = false;
        rysuj();
        // Fala 6A: „Sprawdz” z panelu — dokladnie klikniety zestaw. Tylko
        // wypelnienie siatki (te same klikniecia co „Wczytaj”), bez „Sprawdz”.
        var p = wezPrzekaz('sprawdzarka');
        if (p) {
            var akt = aktywnyPrzycisk();
            if (!akt || akt.getAttribute('data-gra') !== p.gra) {
                Array.prototype.forEach.call(korzen.querySelectorAll('.kupon-gra'), function (b) {
                    if (b.getAttribute('data-gra') === p.gra && b.getAttribute('aria-pressed') !== 'true') { b.click(); }
                });
            }
            var zz = S.lista(p.gra).filter(function (x) { return x.id === p.id; })[0];
            if (zz) { wczytaj(p.id); } else { status.textContent = tekst(en, 'przekazBrak'); }
        }
    }

    /* Strona wynikow: zapisane zestawy gry porownane z NAJNOWSZYM losowaniem,
       ktore strona juz wyrenderowala (data-liczby / data-dodatkowe). Bez
       zapisow sekcja zostaje ukryta. Kwot nie pokazujemy — to nie sprawdzarka. */
    function widokWyniki(doc, S, en, box) {
        var kod = box.getAttribute('data-gra');
        var miejsce = box.querySelector('[data-mz-lista]');
        if (!kod || !miejsce || !S.reguly(kod)) { return; }
        var los = [], losD = [];
        try { los = JSON.parse(box.getAttribute('data-liczby') || '[]'); } catch (e) { los = []; }
        try { losD = JSON.parse(box.getAttribute('data-dodatkowe') || '[]'); } catch (e) { losD = []; }
        var r = S.reguly(kod), zgloszone = false, ocenione = false;
        var nowy = box.querySelector('[data-mz-nowy]');
        var idStrony = box.getAttribute('data-losowanie') || '';
        function rysuj() {
            var zestawy = S.lista(kod);
            wyczysc(miejsce);
            box.hidden = zestawy.length === 0 || !los.length;
            if (box.hidden) { return; }
            miejsce.appendChild(listaZestawow(doc, en, kod, zestawy, function (li, z) {
                var w = S.porownaj(z, los, r.dodatkowe ? losD : []);
                li.appendChild(kule(doc, en, kod, z, w));
                var t = tekst(en, 'trafienia', w.glowne, z.numbers.length) + (w.glowne ? ' (' + w.trafione.join(', ') + ')' : '');
                if (r.dodatkowe && z.extra.length) {
                    t += '; ' + tekst(en, 'trafieniaDod', w.dodatkowe, z.extra.length) + (w.dodatkowe ? ' (' + w.trafioneDodatkowe.join(', ') + ')' : '');
                }
                var p = el(doc, 'span', 'tekst-maly', t);
                p.dataset.mzTrafienia = String(w.glowne) + (r.dodatkowe && z.extra.length ? '+' + w.dodatkowe : '');
                li.appendChild(p);
            }));
            if (!zgloszone) { zgloszone = true; S.zdarzenie('my_ticket_check_latest', kod, 'wyniki', zestawy.length); }
            // Fala 2: raz na wejscie, dopiero po wyrenderowaniu listy. Najpierw
            // komunikat na tej stronie, potem zapis ID jako widzianego.
            if (!ocenione) {
                ocenione = true;
                var d = S.widziane(kod, idStrony);
                if (nowy) { nowy.hidden = !d.pokaz; }
                if (d.zapisz) { S.zapiszWidziane(kod, idStrony); }
            }
        }
        // Kontynuacja z karty („Po tym losowaniu”): zwykle <a href>, nawigacji nie
        // blokujemy; do GA4 idzie tylko gra, zrodlo i przedzial liczby zestawow.
        box.addEventListener('click', function (e) {
            var a = e.target && e.target.closest ? e.target.closest('a[data-mz-dalej]') : null;
            if (a && box.contains(a)) { S.zdarzenie('result_followup_click', kod, 'wyniki', S.lista(kod).length, { mode: a.getAttribute('data-mz-cel') || '' }); }
        });
        doc.addEventListener(ZDARZENIE, function (e) { if (!e.detail || e.detail.game === kod) { rysuj(); } });
        rysuj();
    }

    /* Strona glowna: karta „Moje gry” (Fala 3). Wiersze gier i adresy sa w SSR;
       tu tylko wybor, kolejnosc i liczba zestawow. Nowsze losowania sa
       pokazywane osobno w zwartym panelu nad wynikami. */
    var MAX_MOJE_GRY = 3;
    function widokMojeGry(doc, S, en, box) {
        var lista = box.querySelector('[data-mz-moje-gry-lista]');
        if (!lista) { return; }
        var wiersze = Array.prototype.slice.call(lista.querySelectorAll('[data-mz-gra-wiersz]'));
        function rysuj() {
            var gry = wiersze.map(function (w) {
                var kod = w.getAttribute('data-gra');
                var poz = parseInt(w.getAttribute('data-kolejnosc'), 10);
                return { w: w, kod: kod, ile: S.reguly(kod) ? S.lista(kod).length : 0, poz: isFinite(poz) ? poz : 99 };
            }).filter(function (x) { return x.ile > 0; });
            gry.sort(function (a, b) { return (b.ile - a.ile) || (a.poz - b.poz); });
            var pokaz = gry.slice(0, MAX_MOJE_GRY);
            wiersze.forEach(function (w) { w.hidden = true; });
            pokaz.forEach(function (x) {
                lista.appendChild(x.w);          // kolejnosc w DOM = kolejnosc na ekranie i dla czytnika
                x.w.hidden = false;
                var ile = x.w.querySelector('[data-mz-ile]');
                if (ile) { ile.textContent = liczbaZestawow(en, x.ile); }
            });
            box.hidden = pokaz.length === 0;
        }
        doc.addEventListener(ZDARZENIE, rysuj);
        rysuj();
    }

    /* ── STALY SKROT „MOJE KUPONY” (Fala 4.3A, 25.09.2026) ──────────────────
       Markup w layout/_moje-zestawy.html.twig na kazdej zwyklej stronie:
       [data-mk-skrot] (SSR `hidden`) z przyciskiem [data-mk-otworz] i licznikiem
       [data-mk-licznik] oraz <dialog data-mk-panel> z lista [data-mk-lista].
       Skrot widac także przy pustym magazynie. Wtedy otwiera formularz dodawania,
       a po zapisaniu pokazuje licznik i listę poprawnych zestawów (S.lista()).
       Niedostępny magazyn daje czytelny komunikat przy próbie zapisu.
       Panel: nazwa zestawu i liczby dokladnie z localStorage (kule()), przy
       kazdej grze zwykly <a> do sprawdzarki z publicznym ?gra=kod — zadnych
       liczb ani nazw w URL, zadnego GA4, zadnego zapisu do klucza widzianych.
       <dialog>.showModal() daje top layer, pulapke fokusu i Escape (zdarzenie
       `cancel`); fokus wraca na przycisk skrotu w `close`. Odswiezenie: po
       ZDARZENIE (zapis/usuniecie/wczytanie/import i `storage` z innej karty).
       Dolna reklama zakotwiczona Google (ins[data-anchor-status="displayed"]
       na produkcji; na www4 wylaczona) podnosi skrot o swoja wysokosc przez
       zmienna --mk-odstep-dol, zeby jej nie zaslaniac. */
    function licznikSkrotu(n) { return n > 99 ? '99+' : String(n); }
    /** Jeden wybor zapisanego zestawu dla formularzy, ktore wymagaja pelnego
        zestawu gry. Liczby trafiaja tylko do pol formularza, nigdy do URL. */
    function widokWczytajDoAnalizy(doc, S, en, korzen) {
        var kod = korzen.getAttribute('data-gra'), formularz = korzen.querySelector('[data-zestaw-form], [data-f6-form]');
        var podobne = korzen.hasAttribute('data-f6-podobne');
        var pola = korzen.querySelectorAll('[data-zestaw-liczba]');
        var glowne = korzen.querySelector('[data-f6-main]'), dodatkowe = korzen.querySelector('[data-f6-special]');
        var r = S.reguly(kod);
        if (!formularz || !r || (!podobne && !pola.length) || (podobne && !glowne)) { return; }
        var ramka = el(doc, 'div', 'mk-wczytaj');
        var podpis = el(doc, 'label', 'etykieta', jst("moje_zestawy_js.26d7a5d2f3c5"));
        var wybor = el(doc, 'select', 'pole');
        var id = 'mk-wczytaj-' + Math.random().toString(36).slice(2);
        wybor.id = id; podpis.htmlFor = id;
        var przycisk = el(doc, 'button', 'przycisk', jst("moje_zestawy_js.d8ea94ee9750"));
        przycisk.type = 'button';
        var status = el(doc, 'p', 'podpowiedz'); status.setAttribute('role', 'status');
        var kontekst = el(doc, 'section', 'mk-wczytaj__kontekst'); kontekst.hidden = true;
        kontekst.setAttribute('aria-live', 'polite');
        var kontekstNag = el(doc, 'strong', 'mk-wczytaj__nazwa');
        var kontekstMeta = el(doc, 'p', 'tekst-maly');
        var kontekstLiczby = el(doc, 'div', 'mk-wczytaj__liczby');
        var kontekstAkcje = el(doc, 'div', 'mk-wczytaj__akcje');
        var zmien = el(doc, 'button', 'przycisk', jst("moje_zestawy_js.e74daab823f9")); zmien.type = 'button';
        var edytuj = el(doc, 'button', 'przycisk', jst("moje_zestawy_js.3951ce074caa")); edytuj.type = 'button';
        var sprawdz = el(doc, 'button', 'przycisk', jst("moje_zestawy_js.ff49e011df3f")); sprawdz.type = 'button';
        kontekstAkcje.appendChild(zmien); kontekstAkcje.appendChild(edytuj); kontekstAkcje.appendChild(sprawdz);
        kontekst.appendChild(kontekstNag); kontekst.appendChild(kontekstMeta); kontekst.appendChild(kontekstLiczby); kontekst.appendChild(kontekstAkcje);
        var skrot = doc.querySelector('[data-mk-skrot]');
        var adresSprawdzarki = skrot ? (skrot.getAttribute('data-mk-sprawdzarka') || '').split('?')[0] : '';
        var linkSprawdz = el(doc, 'a', '', jst("moje_zestawy_js.c387011d6eb8"));
        linkSprawdz.hidden = true;
        if (adresSprawdzarki) { linkSprawdz.setAttribute('href', adresSprawdzarki + '?gra=' + encodeURIComponent(kod)); }
        ramka.appendChild(podpis); ramka.appendChild(wybor); ramka.appendChild(przycisk); ramka.appendChild(kontekst); ramka.appendChild(status); ramka.appendChild(linkSprawdz);
        // Multi Multi (decyzja 1, 26.09.2026): tryb „Moj kupon — 1-10 liczb” w tym samym korzeniu.
        var kuponPole = korzen.querySelector('[data-mm-kupon-liczby]');
        var kuponRadio = korzen.querySelector('[data-mm-tryb-kupon]'), pelneRadio = korzen.querySelector('[data-mm-tryb-pelne]');
        var trybBox = korzen.querySelector('[data-mm-tryb]');
        var aktywnyId = null, aktywnyUpdated = '', sygnaturaPoWczytaniu = '', brudny = false;
        if (trybBox) { trybBox.parentNode.insertBefore(ramka, trybBox); } else { formularz.insertBefore(ramka, formularz.firstChild); }
        function kuponowy(z) { return !!(kuponPole && kuponRadio) && !podobne && z.numbers.length !== pola.length && z.numbers.length >= 1 && z.numbers.length <= 10; }
        function pasuje(z) {
            var wymagana = podobne ? Number(korzen.getAttribute('data-typuje')) : pola.length;
            return (z.numbers.length === wymagana && (!podobne || !r.dodatkowe || (z.extra || []).length === r.dodatkowe.ile)) || kuponowy(z);
        }
        function wybierzTryb(radio) {
            if (!radio || radio.checked) { return; }
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));   // analizator-kupon.js czysci ukryty formularz
        }
        function odswiez(zdarzenieMagazynu) {
            var poprzedni = wybor.value, lista = S.lista(kod).filter(pasuje);
            wyczysc(wybor);
            var p = el(doc, 'option', '', jst("moje_zestawy_js.0345b9623b4d")); p.value = ''; wybor.appendChild(p);
            lista.forEach(function (z) { var o = el(doc, 'option', '', z.name + ' (' + z.numbers.join(', ') + ')'); o.value = z.id; wybor.appendChild(o); });
            wybor.value = lista.some(function (z) { return z.id === poprzedni; }) ? poprzedni : '';
            // Fala 6A: sa zestawy tej gry, ale zaden nie pasuje (np. Multi Multi:
            // kupon 1-10 liczb, analizator 20) — mowimy dlaczego, zamiast chowac.
            var niezgodne = !lista.length && S.lista(kod).length > 0;
            ramka.className = 'mk-wczytaj' + (niezgodne ? ' mk-wczytaj--niezgodne' : '');
            ramka.hidden = !lista.length && !niezgodne;
            if (niezgodne) {
                status.textContent = tekst(en, 'niezgodneGra', r.nazwa, podobne ? Number(korzen.getAttribute('data-typuje')) : pola.length);
                if (adresSprawdzarki) { linkSprawdz.hidden = false; }
            } else {
                if (/^(?:Masz zapisane|You have saved)/.test(status.textContent)) { status.textContent = ''; }
                linkSprawdz.hidden = true;
            }
            odswiezKontekst(!!zdarzenieMagazynu);
        }
        function wartoscPola(pole) { return String(pole && pole.value || '').trim().replace(/\s+/g, ' '); }
        function sygnaturaFormularza() {
            if (kuponPole && kuponRadio && kuponRadio.checked) { return 'kupon:' + wartoscPola(kuponPole); }
            if (podobne) { return 'podobne:' + wartoscPola(glowne) + '|' + wartoscPola(dodatkowe); }
            return 'pola:' + Array.prototype.map.call(pola, wartoscPola).join('|');
        }
        function aktywnyZestaw() {
            if (!aktywnyId) { return null; }
            return S.lista(kod).filter(function (z) { return z.id === aktywnyId; })[0] || null;
        }
        function pokazKontekst(z) {
            wyczysc(kontekstLiczby);
            if (!z) { kontekst.hidden = true; return; }
            kontekst.hidden = false;
            kontekstNag.textContent = z.name;
            nazwaZGra(doc, kontekstMeta, kod, r.nazwa + (brudny ? (jst("moje_zestawy_js.2b2d935a81b6")) : ''));
            kontekstLiczby.appendChild(kule(doc, en, kod, z, null));
            sprawdz.hidden = !adresSprawdzarki;
        }
        function odswiezKontekst(zdarzenieMagazynu) {
            if (!aktywnyId) { pokazKontekst(null); return; }
            var z = aktywnyZestaw();
            if (!z) {
                aktywnyId = null; aktywnyUpdated = '';
                pokazKontekst(null);
                status.textContent = brudny
                    ? (jst("moje_zestawy_js.335b666f9c90"))
                    : (jst("moje_zestawy_js.7485ef05c531"));
                return;
            }
            var zmienionyWTle = zdarzenieMagazynu && aktywnyUpdated && String(z.updated || z.created || '') !== aktywnyUpdated;
            if (zmienionyWTle && brudny) {
                pokazKontekst(z);
                status.textContent = jst("moje_zestawy_js.da0b908aeb4b");
                return;
            }
            if (zmienionyWTle && !brudny) {
                wypelnij(z); sygnaturaPoWczytaniu = sygnaturaFormularza();
                status.textContent = jst("moje_zestawy_js.db156919193b");
            }
            aktywnyUpdated = String(z.updated || z.created || '');
            pokazKontekst(z);
        }
        function wypelnij(z) {
            if (kuponowy(z)) { wybierzTryb(kuponRadio); kuponPole.value = z.numbers.join(' '); return; }
            if (kuponRadio) { wybierzTryb(pelneRadio); }
            if (podobne) {
                glowne.value = z.numbers.join(' ');
                if (dodatkowe) { dodatkowe.value = (z.extra || []).join(' '); }
            } else {
                Array.prototype.forEach.call(pola, function (pole, i) { pole.value = String(z.numbers[i]); pole.dispatchEvent(new Event('input', { bubbles: true })); });
            }
        }
        przycisk.addEventListener('click', function () {
            var z = S.lista(kod).filter(pasuje).find(function (x) { return x.id === wybor.value; });
            if (!z) { status.textContent = jst("moje_zestawy_js.1cc8c25f9ede"); return; }
            wypelnij(z);
            aktywnyId = z.id; aktywnyUpdated = String(z.updated || z.created || '');
            sygnaturaPoWczytaniu = sygnaturaFormularza(); brudny = false; pokazKontekst(z);
            status.textContent = jst("moje_zestawy_js.fb6b1051beae");
        });
        formularz.addEventListener('input', function (e) {
            if (!aktywnyId || ramka.contains(e.target)) { return; }
            brudny = sygnaturaFormularza() !== sygnaturaPoWczytaniu; pokazKontekst(aktywnyZestaw());
        });
        formularz.addEventListener('change', function (e) {
            if (!aktywnyId || ramka.contains(e.target)) { return; }
            brudny = sygnaturaFormularza() !== sygnaturaPoWczytaniu; pokazKontekst(aktywnyZestaw());
        });
        zmien.addEventListener('click', function () { wybor.focus(); });
        edytuj.addEventListener('click', function () {
            var z = aktywnyZestaw(), panel = panelApi;
            if (!z || !panel || typeof panel.formularz !== 'function') { status.textContent = jst("moje_zestawy_js.f80220fcac35"); return; }
            panel.formularz(kod, z, null, { powrot: edytuj, poZapisie: function (t) { status.textContent = t; odswiez(); } });
        });
        sprawdz.addEventListener('click', function () {
            var z = aktywnyZestaw();
            if (!z || !adresSprawdzarki) { return; }
            zapiszPrzekaz('sprawdzarka', kod, z.id);
            root.location.assign(adresSprawdzarki + '?gra=' + encodeURIComponent(kod));
        });
        doc.addEventListener(ZDARZENIE, function () { odswiez(true); });
        odswiez();
        // Fala 6A: „Analizuj” z panelu — dokladnie klikniety zestaw tej gry.
        // Wypelniamy pola i mowimy, co dalej; formularza NIE wysylamy.
        var p = wezPrzekaz('analiza', kod);
        if (p) {
            var det = korzen.closest ? korzen.closest('details') : null;
            if (det) { det.open = true; }
            var z = S.lista(kod).find(function (x) { return x.id === p.id; });
            ramka.hidden = false;
            if (!z) {
                status.textContent = tekst(en, 'przekazBrak');
            } else if (!pasuje(z)) {
                var wym = podobne ? Number(korzen.getAttribute('data-typuje')) : pola.length;
                status.textContent = tekst(en, 'przekazNiezgodny', z.name, z.numbers.length, wym);
            } else {
                wybor.value = z.id;
                wypelnij(z);
                aktywnyId = z.id; aktywnyUpdated = String(z.updated || z.created || '');
                sygnaturaPoWczytaniu = sygnaturaFormularza(); brudny = false; pokazKontekst(z);
                status.textContent = tekst(en, 'przekazAnaliza', z.name);
            }
            if (typeof ramka.scrollIntoView === 'function') { try { ramka.scrollIntoView({ block: 'center' }); } catch (e) { /* stary silnik */ } }
        }
    }
    /* ── FALA 6A/6B: WSPOLNE AKCJE ZESTAWU (panel i centrum „Moje kupony”) ────
       Jeden kontroler dla wiersza zestawu: sprawdz / analizuj / edytuj /
       duplikuj / usun z potwierdzeniem w wierszu i „Cofnij” do kolejnej
       operacji. Panel i centrum maja wlasne instancje (wlasny status i cofniecie),
       ale ten sam kod — akcje sa identyczne w obu miejscach. */
    function t6(en, k, a, b, c) {
        return komunikatJezykowy('js_actions', en, k, [a, b, c]);
    }
    /** Czy zestaw da sie otworzyc w analizatorze gry: pelny zestaw (pick) albo —
        Multi Multi, decyzja 1 z 26.09.2026 — kupon 1-10 liczb (tryb „Moj kupon”). */
    function doAnalizatora(r, z) {
        return z.numbers.length === r.pick || (r.kod === 'multi-multi' && z.numbers.length >= 1 && z.numbers.length <= 10);
    }
    /** o = { korzen, komunikat(t, blad), odswiez(), cofnijWrap, cofnijPrzycisk, sprawdzarka,
              analizatory, formularz(kod, zestaw, kopiaZ, zrodloFokusu), historia(kod, z)?, fokusZapasowy() } */
    function kontrolerAkcji(doc, S, en, o) {
        var potwierdzany = null, doCofniecia = null;
        function pokazCofnij(tak) { if (o.cofnijWrap) { o.cofnijWrap.hidden = !tak; } }
        function wyczyscCofnij() { doCofniecia = null; pokazCofnij(false); }
        function zestawPo(kod, id) { return S.lista(kod).filter(function (x) { return x.id === id; })[0] || null; }
        function przycisk(napis, aria, akcja, cel) {
            var b = el(doc, 'button', jst("ui.c6f62909f0014c6a") + akcja, napis);
            b.type = 'button';
            b.setAttribute('data-mk-akcja', akcja);
            b.setAttribute('data-mk-cel', cel);
            b.setAttribute('aria-label', aria);
            return b;
        }
        /* Piec akcji przy KAZDYM zestawie (plus „Historia” w centrum), wszystkie
           widoczne — na 360 px zawijaja sie w rzedy po 44 px, bez menu „wiecej”. */
        function wierszAkcji(kod, z) {
            var cel = kod + ':' + z.id;
            if (potwierdzany === cel) {
                var box2 = el(doc, 'div', 'mk-potwierdz');
                box2.setAttribute('role', 'group');
                var id = 'mk-pyt-' + (o.prefiks || '') + cel.replace(/[^A-Za-z0-9_-]/g, '-');
                var p = el(doc, 'p', '', t6(en, 'pytanie', z.name)); p.id = id;
                box2.setAttribute('aria-labelledby', id);
                box2.appendChild(p);
                box2.appendChild(przycisk(t6(en, 'tak'), t6(en, 'tak'), 'usun-tak', cel));
                box2.appendChild(przycisk(t6(en, 'nie'), t6(en, 'nie'), 'usun-nie', cel));
                return box2;
            }
            var box = el(doc, 'div', 'mk-akcje');
            box.setAttribute('role', 'group');
            box.setAttribute('aria-label', t6(en, 'akcjeAria', z.name));
            box.appendChild(przycisk(t6(en, 'sprawdz'), t6(en, 'sprawdzAria', z.name), 'sprawdz', cel));
            if (o.analizatory[kod]) { box.appendChild(przycisk(t6(en, 'analizuj'), t6(en, 'analizujAria', z.name), 'analizuj', cel)); }
            if (o.raporty && o.raporty[kod]) { box.appendChild(przycisk(t6(en, 'raport'), t6(en, 'raportAria', z.name), 'raport', cel)); }
            var edit = przycisk(t6(en, 'edytuj'), t6(en, 'edytujAria', z.name), 'edytuj', cel);
            edit.setAttribute('data-mk-edytuj', cel);          // znacznik z Fali 5 (testy)
            box.appendChild(edit);
            box.appendChild(przycisk(t6(en, 'duplikuj'), t6(en, 'duplikujAria', z.name), 'duplikuj', cel));
            box.appendChild(przycisk(t6(en, 'usun'), t6(en, 'usunAria', z.name), 'usun', cel));
            if (o.historia) { box.appendChild(przycisk(t6(en, 'historia'), t6(en, 'historiaAria', z.name), 'historia', cel)); }
            return box;
        }
        function fokusNa(akcja, cel) {
            var x = o.korzen.querySelector('[data-mk-akcja="' + akcja + '"][data-mk-cel="' + cel + '"]');
            if (x && typeof x.focus === 'function') { x.focus(); }
            return !!x;
        }
        function doNarzedzia(cel, kod, z, adres) {
            wyczyscCofnij();
            zapiszPrzekaz(cel, kod, z.id);                   // bez sessionStorage: narzedzie otworzy sie puste
            root.location.assign(adres);                     // adres ma tylko publiczny kod gry
        }
        function obsluz(b) {
            var akcja = b.getAttribute('data-mk-akcja'), cel = b.getAttribute('data-mk-cel') || '';
            var i = cel.indexOf(':'), kod = cel.slice(0, i), id = cel.slice(i + 1);
            var r = S.reguly(kod), z = zestawPo(kod, id);
            if (akcja === 'usun-nie') { potwierdzany = null; o.odswiez(); fokusNa('usun', cel); return; }
            if (!r || !z) { potwierdzany = null; o.komunikat(tekst(en, 'przekazBrak'), true); o.odswiez(); return; }
            if (akcja === 'sprawdz') {
                if (z.numbers.length > r.kupon) { o.komunikat(tekst(en, 'zaDuzo', z.name, z.numbers.length, r.nazwa, r.kupon), true); return; }
                if (o.sprawdzarka) { doNarzedzia('sprawdzarka', kod, z, o.sprawdzarka + '?gra=' + encodeURIComponent(kod)); }
                return;
            }
            if (akcja === 'analizuj') {
                if (!doAnalizatora(r, z)) { o.komunikat(t6(en, 'zaDuzoAnaliza', z.name, z.numbers.length, r.pick), true); return; }
                if (o.analizatory[kod]) { doNarzedzia('analiza', kod, z, o.analizatory[kod]); }
                return;
            }
            if (akcja === 'raport') {
                if (o.raporty && o.raporty[kod]) { doNarzedzia('raport', kod, z, o.raporty[kod]); }
                return;
            }
            if (akcja === 'historia' && o.historia) { o.historia(kod, z); return; }
            wyczyscCofnij();
            if (akcja === 'edytuj') { potwierdzany = null; o.formularz(kod, z, null, b); return; }
            if (akcja === 'duplikuj') {
                potwierdzany = null;
                if (S.lista(kod).length >= LIMIT) { o.komunikat(t6(en, 'limit', LIMIT), true); return; }
                o.formularz(kod, null, z, b);
                return;
            }
            if (akcja === 'usun') { potwierdzany = cel; o.komunikat(''); o.odswiez(); fokusNa('usun-nie', cel); return; }
            if (akcja === 'usun-tak') {
                var indeks = S.lista(kod).map(function (x) { return x.id; }).indexOf(id);
                potwierdzany = null;
                var w = S.usun(kod, id);
                if (!w.ok) { o.komunikat(w.blad === 'niedostepny' ? tekst(en, 'niedostepny') : tekst(en, 'bladZapisu'), true); o.odswiez(); return; }
                doCofniecia = { kod: kod, zestaw: z, indeks: indeks };
                o.odswiez();
                o.komunikat(t6(en, 'usunieto', z.name));
                pokazCofnij(true);
                if (o.cofnijPrzycisk && typeof o.cofnijPrzycisk.focus === 'function') { o.cofnijPrzycisk.focus(); }
            }
        }
        o.korzen.addEventListener('click', function (e) {
            var b = e.target && e.target.closest ? e.target.closest('[data-mk-akcja]') : null;
            if (b && o.korzen.contains(b)) { obsluz(b); }
        });
        if (o.cofnijPrzycisk) { o.cofnijPrzycisk.addEventListener('click', function () {
            var c = doCofniecia;
            wyczyscCofnij();
            if (!c) { return; }
            var w = S.przywroc(c.kod, c.zestaw, c.indeks);
            o.odswiez();
            if (w.ok) {
                o.komunikat(t6(en, 'przywrocono', c.zestaw.name));
                if (!fokusNa('sprawdz', c.kod + ':' + c.zestaw.id)) { o.fokusZapasowy(); }
            } else {
                o.komunikat(w.blad === 'niedostepny' ? tekst(en, 'niedostepny') : t6(en, 'niePrzywrocono', LIMIT), true);
                o.fokusZapasowy();
            }
        }); }
        return {
            wiersz: wierszAkcji, fokusNa: fokusNa, wyczyscCofnij: wyczyscCofnij,
            reset: function () { potwierdzany = null; wyczyscCofnij(); }
        };
    }

    /* Kopia zapasowa. Eksport = istniejacy eksport() kazdej gry w jednym pakiecie;
       import = S.importujPlik() — caly plik albo nic. Wspolne dla panelu i centrum. */
    function dataPliku() {
        var d = new Date(), p = function (n) { return (n < 10 ? '0' : '') + n; };
        return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
    }
    function przygotujPlik(S, en) {
        var pakiet = S.eksportWszystko(), ile = 0;
        pakiet.games.forEach(function (g) { ile += g.sets.length; });
        if (!ile) { return { ok: false, t: t6(en, 'eksportPusty'), zly: false }; }
        return {
            ok: true, ile: ile,
            nazwa: (jst("moje_zestawy_js.5c18053a5b4c")) + dataPliku() + '.json',
            tekst: JSON.stringify(pakiet, null, 2)
        };
    }
    function pobierzPlik(doc, dane, rodzic) {
        try {
            var blob = new root.Blob([dane.tekst], { type: 'application/json' });
            var url = root.URL.createObjectURL(blob);
            var a = el(doc, 'a');
            a.href = url; a.download = dane.nazwa; a.hidden = true;
            rodzic.appendChild(a); a.click(); rodzic.removeChild(a);
            root.setTimeout(function () { try { root.URL.revokeObjectURL(url); } catch (e) { /* nic */ } }, 1000);
            return true;
        } catch (e) { return false; }
    }
    function eksportujPlik(doc, S, en, rodzic) {
        var dane = przygotujPlik(S, en);
        if (!dane.ok) { return dane; }
        return pobierzPlik(doc, dane, rodzic)
            ? { t: t6(en, 'eksportOk', dane.ile), zly: false }
            : { t: t6(en, 'eksportBlad'), zly: true };
    }
    /** Udostepnia TEN SAM plik co eksport. Bez konta, serwera i drugiego formatu.
        Brak Web Share API albo blad inny niz anulowanie -> bezpieczny download. */
    function przeniesPlik(doc, S, en, rodzic) {
        var dane = przygotujPlik(S, en);
        if (!dane.ok) { return root.Promise.resolve(dane); }
        var nav = root.navigator;
        if (nav && typeof nav.share === 'function' && typeof nav.canShare === 'function' && typeof root.File === 'function') {
            try {
                var plik = new root.File([dane.tekst], dane.nazwa, { type: 'application/json' });
                if (nav.canShare({ files: [plik] })) {
                    return nav.share({ files: [plik], title: t6(en, 'transferTytul'), text: t6(en, 'transferTekst') })
                        .then(function () { return { t: t6(en, 'transferOk', dane.ile), zly: false }; })
                        .catch(function (e) {
                            if (e && e.name === 'AbortError') { return { t: t6(en, 'transferAnulowano'), zly: false, anulowano: true }; }
                            return pobierzPlik(doc, dane, rodzic)
                                ? { t: t6(en, 'transferFallback'), zly: false, fallback: true }
                                : { t: t6(en, 'eksportBlad'), zly: true };
                        });
                }
            } catch (e) { /* fallback ponizej */ }
        }
        return root.Promise.resolve(pobierzPlik(doc, dane, rodzic)
            ? { t: t6(en, 'transferFallback'), zly: false, fallback: true }
            : { t: t6(en, 'eksportBlad'), zly: true });
    }
    /* Link bez konta i klucza. Dane sa w fragmencie #mk=, wiec przegladarka nie
       wysyla ich do serwera ani w Refererze. Base64URL jest kodowaniem, nie
       szyfrowaniem — komunikat w UI mowi o tym wprost. */
    var LINK_PREFIX = '#mk=';
    var LINK_MAX = 7000;
    function utf8DoBase64url(s) {
        if (typeof root.TextEncoder !== 'function' || typeof root.btoa !== 'function') { throw new Error('base64'); }
        var b = new root.TextEncoder().encode(s), bin = '', i;
        for (i = 0; i < b.length; i += 8192) { bin += String.fromCharCode.apply(null, b.subarray(i, i + 8192)); }
        return root.btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
    }
    function base64urlDoUtf8(s) {
        if (typeof root.TextDecoder !== 'function' || typeof root.atob !== 'function' || !/^[A-Za-z0-9_-]+$/.test(s)) { throw new Error('base64'); }
        var p = s.replace(/-/g, '+').replace(/_/g, '/');
        while (p.length % 4) { p += '='; }
        var bin = root.atob(p), b = new Uint8Array(bin.length), i;
        for (i = 0; i < bin.length; i++) { b[i] = bin.charCodeAt(i); }
        return new root.TextDecoder('utf-8', { fatal: true }).decode(b);
    }
    function kompaktowyPakiet(S) {
        var p = S.eksportWszystko(), ile = 0;
        var g = p.games.map(function (gra) {
            ile += gra.sets.length;
            return [gra.game, gra.sets.map(function (z) { return [z.name || '', z.numbers, z.extra || []]; })];
        });
        return { ile: ile, dane: { v: 1, g: g } };
    }
    function rozwinPakietLinku(obj, S) {
        if (!obj || obj.v !== 1 || !Array.isArray(obj.g) || obj.g.length > 6) { throw new Error('format'); }
        var ile = 0, widziane = {}, gry = obj.g.map(function (g) {
            if (!Array.isArray(g) || typeof g[0] !== 'string' || !S.reguly(g[0]) || widziane[g[0]] || !Array.isArray(g[1]) || g[1].length > LIMIT) { throw new Error('format'); }
            widziane[g[0]] = true; ile += g[1].length;
            return { version: WERSJA, game: g[0], sets: g[1].map(function (z) {
                if (!Array.isArray(z) || z.length !== 3 || typeof z[0] !== 'string' || z[0].length > NAZWA_MAX || !Array.isArray(z[1]) || !Array.isArray(z[2])) { throw new Error('format'); }
                return { name: z[0], numbers: z[1], extra: z[2] };
            }) };
        });
        if (!ile) { throw new Error('format'); }
        return { ile: ile, pakiet: { version: WERSJA, format: FORMAT_PAKIETU, games: gry } };
    }
    function utworzLink(S, en, baza) {
        try {
            var k = kompaktowyPakiet(S);
            if (!k.ile) { return { ok: false, t: t6(en, 'eksportPusty'), zly: false }; }
            baza = baza || ((root.location && root.location.origin) ? root.location.origin + (jst("moje_zestawy_js.0d12ed683be7")) : '');
            var url = baza.replace(/#.*$/, '') + LINK_PREFIX + utf8DoBase64url(JSON.stringify(k.dane));
            if (!baza || url.length > LINK_MAX) { return { ok: false, t: t6(en, 'linkZaDlugi'), zly: false, zaDlugi: true }; }
            return { ok: true, url: url, ile: k.ile };
        } catch (e) { return { ok: false, t: t6(en, 'linkBlad'), zly: true }; }
    }
    function kopiujLink(doc, url) {
        var nav = root.navigator;
        if (nav && nav.clipboard && typeof nav.clipboard.writeText === 'function') { return nav.clipboard.writeText(url).then(function () { return true; }); }
        return root.Promise.resolve((function () {
            try {
                var pole = el(doc, 'textarea'); pole.value = url; pole.setAttribute('readonly', ''); pole.classList.add('kopiowanie-ukryte');
                doc.body.appendChild(pole); pole.select(); var ok = doc.execCommand && doc.execCommand('copy'); doc.body.removeChild(pole); return !!ok;
            } catch (e) { return false; }
        })());
    }
    function udostepnijLink(doc, S, en, baza) {
        var d = utworzLink(S, en, baza);
        if (!d.ok) { return root.Promise.resolve(d); }
        var nav = root.navigator;
        if (nav && typeof nav.share === 'function') {
            return nav.share({ title: t6(en, 'transferTytul'), text: t6(en, 'transferTekst'), url: d.url })
                .then(function () { return { t: t6(en, 'linkOk', d.ile), zly: false, url: d.url }; })
                .catch(function (e) {
                    if (e && e.name === 'AbortError') { return { t: t6(en, 'linkAnulowano'), zly: false, anulowano: true }; }
                    return kopiujLink(doc, d.url).then(function (ok) { return { t: ok ? t6(en, 'linkKopia', d.ile) : t6(en, 'linkBlad'), zly: !ok, url: d.url, skopiowano: ok }; });
                });
        }
        return kopiujLink(doc, d.url).then(function (ok) { return { t: ok ? t6(en, 'linkKopia', d.ile) : t6(en, 'linkBlad'), zly: !ok, url: d.url, skopiowano: ok }; });
    }
    function odczytajLink(S, hash) {
        hash = typeof hash === 'string' ? hash : ((root.location && root.location.hash) || '');
        if (hash.indexOf(LINK_PREFIX) !== 0) { return null; }
        try { return Object.assign({ ok: true }, rozwinPakietLinku(JSON.parse(base64urlDoUtf8(hash.slice(LINK_PREFIX.length))), S)); }
        catch (e) { return { ok: false, blad: 'format' }; }
    }
    function usunFragment() {
        try { if (root.history && typeof root.history.replaceState === 'function') { root.history.replaceState(null, '', root.location.pathname); } }
        catch (e) { /* adres bez zmian, import nadal bezpieczny */ }
    }
    function importujLink(S, en, dane) { return komunikatImportu(S, en, dane && dane.ok ? S.importujPlik(dane.pakiet) : { ok: false, blad: 'format' }); }
    function komunikatImportu(S, en, w) {
        var nazwaGry = w.gra && S.reguly(w.gra) ? S.reguly(w.gra).nazwa : '';
        if (w.ok) {
            if (!w.zapisane) { return { t: t6(en, 'importNic'), zly: false }; }
            return { t: t6(en, 'importOk', w.zapisane) + (w.duplikaty ? ' ' + t6(en, 'importDup', w.duplikaty) : ''), zly: false };
        }
        var m = { wersja: t6(en, 'importWersja'), gra: t6(en, 'importGra'), format: t6(en, 'importFormat'), liczby: t6(en, 'importLiczby', nazwaGry), limit: t6(en, 'importLimit', LIMIT, nazwaGry),
            niedostepny: tekst(en, 'niedostepny'), miejsce: tekst(en, 'miejsce') }[w.blad];
        return { t: m || tekst(en, 'bladZapisu'), zly: true };
    }
    /** input[type=file] -> cb({t, zly}) po imporcie. Plik nie wychodzi z przegladarki. */
    function podepnijImport(S, en, input, cb) {
        input.addEventListener('change', function () {
            var f = input.files && input.files[0];
            if (!f) { return; }
            if (f.size > 262144) { input.value = ''; cb({ t: t6(en, 'importDuzy'), zly: true }); return; }
            var czytnik = new root.FileReader();
            czytnik.onerror = function () { input.value = ''; cb({ t: t6(en, 'importCzytanie'), zly: true }); };
            czytnik.onload = function () {
                input.value = '';
                var obj;
                try { obj = JSON.parse(String(czytnik.result || '')); } catch (e) { cb({ t: t6(en, 'importJson'), zly: true }); return; }
                cb(komunikatImportu(S, en, S.importujPlik(obj)));
            };
            czytnik.readAsText(f);
        });
    }

    var panelApi = null;                 // widokSkrot -> centrum: formularz w tym samym <dialog>
    function widokSkrot(doc, S, en, box) {
        var przycisk = box.querySelector('[data-mk-otworz]');
        var licznik = box.querySelector('[data-mk-licznik]');
        var licznikOpis = box.querySelector('[data-mk-licznik-opis]');
        var panel = doc.querySelector('[data-mk-panel]');
        var miejsce = panel ? panel.querySelector('[data-mk-lista]') : null;
        var zamknij = panel ? panel.querySelector('[data-mk-zamknij]') : null;
        if (!przycisk || !licznik || !panel || !miejsce) { return; }
        var sprawdzarka = (box.getAttribute('data-mk-sprawdzarka') || '').split('?')[0];
        var analizatory = {};
        try { analizatory = JSON.parse(box.getAttribute('data-mk-analizatory') || '{}'); } catch (e) { analizatory = {}; }
        var raporty = {};
        try { raporty = JSON.parse(box.getAttribute('data-mk-raporty') || '{}'); } catch (e) { raporty = {}; }
        var tekstSkrotu = box.querySelector('[data-mk-tekst]');
        var etykietaPusta = box.getAttribute('data-mk-label-empty') || (jst("moje_zestawy_js.ae52e425a5a3"));
        var etykietaZapisane = box.getAttribute('data-mk-label-saved') || (jst("moje_zestawy_js.8933a4de9c91"));
        var wskazowka = panel.querySelector('[data-mk-wskazowka]');
        var wskazowkaZamknij = panel.querySelector('[data-mk-wskazowka-zamknij]');
        var pusto = panel.querySelector('[data-mk-pusto]');
        var forma = panel.querySelector('[data-mk-form]');
        var poleGra = panel.querySelector('[data-mk-form-gra]');
        var poleNazwa = panel.querySelector('[data-mk-form-nazwa]');
        var poleLiczby = panel.querySelector('[data-mk-form-liczby]');
        var poleDodatkowe = panel.querySelector('[data-mk-form-dodatkowe]');
        var dodatkoweWrap = panel.querySelector('[data-mk-form-dodatkowe-wrap]');
        var regulyOpis = panel.querySelector('[data-mk-form-reguly]');
        var bladPola = panel.querySelector('[data-mk-form-blad]');
        var status = panel.querySelector('[data-mk-status]');
        var graDomyslna = box.getAttribute('data-mk-default-game') || '';
        var zapiszPrzycisk = forma ? forma.querySelector('button[type="submit"]') : null;
        var edytowany = null;
        var widok = 'lista';
        var html = doc.documentElement;
        var kopiaOpis = panel.querySelector('[data-mk-form-kopia]');
        var eksportPrzycisk = panel.querySelector('[data-mk-eksport]');
        var importPrzycisk = panel.querySelector('[data-mk-import]');
        var wskazowkaSesja = false;       // zamknieta w tej karcie (gdy localStorage nie przyjmie znacznika)
        var kopiaWzor = null;             // { kod, sig } oryginalu duplikatu (decyzja 2, 26.09.2026)
        var zZewnatrz = null;             // { poZapisie(t), powrot } — formularz otwarty z centrum

        function komunikat(t, blad) {
            if (!status) { return; }
            status.textContent = t || '';
            status.className = blad ? 'blad-pola' : 'podpowiedz';
        }
        function bladForm(t) { if (bladPola) { bladPola.textContent = t || ''; bladPola.hidden = !t; } }
        var akcje = kontrolerAkcji(doc, S, en, {
            korzen: panel, prefiks: 'p-', komunikat: komunikat, odswiez: function () { rysujPanel(zestawyGier().gry); },
            cofnijWrap: panel.querySelector('[data-mk-cofnij-wrap]'), cofnijPrzycisk: panel.querySelector('[data-mk-cofnij]'),
            sprawdzarka: sprawdzarka, analizatory: analizatory, raporty: raporty,
            formularz: function (kod, zestaw, kopiaZ) { nowyFormularz(kod, zestaw, kopiaZ); },
            fokusZapasowy: function () { if (zamknij) { zamknij.focus(); } }
        });
        function pokazWidok(nowy) {
            widok = nowy;
            Array.prototype.forEach.call(panel.querySelectorAll('[data-mk-sekcja]'), function (s) { s.hidden = s.getAttribute('data-mk-sekcja') !== nowy; });
            Array.prototype.forEach.call(panel.querySelectorAll('[data-mk-widok]'), function (b) { b.setAttribute('aria-current', b.getAttribute('data-mk-widok') === nowy ? 'page' : 'false'); });
            bladForm('');
            if (nowy === 'lista') { rysujPanel(zestawyGier().gry); }
            if (nowy === 'formularz' && poleGra) { poleGra.focus(); }
        }
        function aktualneReguly() {
            var r = S.reguly(poleGra.value);
            if (!r) { return; }
            var ile = r.kod === 'multi-multi' ? 10 : r.pick;
            if (regulyOpis) { regulyOpis.textContent = (jst("moje_zestawy_js.9884d5a6dbbd")) + (r.kod === 'multi-multi' ? (jst("moje_zestawy_js.2f36ec08fed4")) : '') + ile + (jst("moje_zestawy_js.b6650b6bf785")) + r.pula + (r.dodatkowe ? (jst("moje_zestawy_js.1477c63ef5e3")) + r.dodatkowe.ile + (jst("moje_zestawy_js.650de4c75942")) + r.dodatkowe.pula : '') + '.'; }
            if (dodatkoweWrap) { dodatkoweWrap.hidden = !r.dodatkowe; }
            if (!r.dodatkowe && poleDodatkowe) { poleDodatkowe.value = ''; }
        }
        function liczbyZPola(pole) {
            var s = String(pole.value || '').trim();
            if (!s) { return []; }
            return s.split(/[\s,;]+/).map(function (v) { return Number(v); });
        }
        /** Sygnatura z formularza (po normalizacji) albo null, gdy liczby sa niepoprawne. */
        function sygnaturaFormularza() {
            var n = S.normalizuj(poleGra.value, liczbyZPola(poleLiczby), liczbyZPola(poleDodatkowe));
            return n.ok ? n.liczby.join(',') + '|' + n.dodatkowe.join(',') : null;
        }
        /** Decyzja 2: kopia z liczbami identycznymi z oryginalem = „Zapisz” nieaktywne. */
        function sprawdzKopie() {
            var ta = !!kopiaWzor && poleGra.value === kopiaWzor.kod && sygnaturaFormularza() === kopiaWzor.sig;
            if (zapiszPrzycisk) {
                zapiszPrzycisk.disabled = ta;
                if (ta) { zapiszPrzycisk.setAttribute('aria-describedby', 'mk-form-kopia'); } else { zapiszPrzycisk.removeAttribute('aria-describedby'); }
            }
            return ta;
        }
        /** kopiaZ = zestaw zrodlowy duplikatu: formularz NOWEGO zestawu z jego
            liczbami i nazwa „… (kopia)”; oryginal nie jest ruszany. */
        function nowyFormularz(kod, zestaw, kopiaZ) {
            kod = kod || graDomyslna;
            edytowany = zestaw ? { kod: kod, id: zestaw.id } : null;
            if (forma) { forma.reset(); }
            if (kod && poleGra) { poleGra.value = kod; }
            if (poleGra) { poleGra.disabled = !!zestaw; }
            var zrodlo = zestaw || kopiaZ;
            if (zrodlo) {
                poleNazwa.value = kopiaZ ? krotkaNazwa(en, S.lista(kod).length, 'panel') : zrodlo.name;
                poleLiczby.value = zrodlo.numbers.join(' ');
                poleDodatkowe.value = (zrodlo.extra || []).join(' ');
            }
            if (!zrodlo) { poleNazwa.value = krotkaNazwa(en, S.lista(kod || poleGra.value).length, 'panel'); }
            kopiaWzor = kopiaZ ? { kod: kod, sig: kopiaZ.numbers.join(',') + '|' + (kopiaZ.extra || []).join(',') } : null;
            if (kopiaOpis) { kopiaOpis.textContent = kopiaZ ? t6(en, 'kopia', kopiaZ.name) : ''; kopiaOpis.hidden = !kopiaZ; }
            aktualneReguly();
            sprawdzKopie();
            komunikat('');
            pokazWidok('formularz');
        }
        function losuj(pula, ile) {
            var p = [], i;
            for (i = 1; i <= pula; i++) { p.push(i); }
            for (i = 0; i < ile; i++) { var j = i + Math.floor(Math.random() * (p.length - i)); var x = p[i]; p[i] = p[j]; p[j] = x; }
            return p.slice(0, ile).sort(rosnaco);
        }
        if (poleGra) {
            S.gry().forEach(function (kod) {
                var r = S.reguly(kod), opt = el(doc, 'option', '', r.nazwa);
                opt.value = kod; poleGra.appendChild(opt);
            });
            if (graDomyslna && S.reguly(graDomyslna)) { poleGra.value = graDomyslna; aktualneReguly(); }
            poleGra.addEventListener('change', function () { aktualneReguly(); sprawdzKopie(); });
        }
        [poleLiczby, poleDodatkowe].forEach(function (p) { if (p) { p.addEventListener('input', sprawdzKopie); } });

        function zestawyGier() {
            var out = [], suma = 0;
            S.gry().forEach(function (kod) {
                var l = S.lista(kod);
                if (l.length) { out.push({ kod: kod, r: S.reguly(kod), zestawy: l }); suma += l.length; }
            });
            return { gry: out, suma: suma };
        }
        function otwarty() { return !!panel.open; }
        function rysujPanel(gry) {
            wyczysc(miejsce);
            gry.forEach(function (g) {
                var sekcja = el(doc, 'section', 'mk-panel__gra');
                sekcja.setAttribute('data-mk-gra', g.kod);
                var naglowek = el(doc, 'div', 'mk-panel__gra-naglowek');
                var h = nazwaZGra(doc, el(doc, 'h3', 'mk-panel__gra-tytul'), g.kod, g.r.nazwa);
                var ile = el(doc, 'span', 'tekst-maly', liczbaZestawow(en, g.zestawy.length));
                ile.setAttribute('data-mk-ile', String(g.zestawy.length));
                naglowek.appendChild(h); naglowek.appendChild(ile);
                sekcja.appendChild(naglowek);
                sekcja.appendChild(listaZestawow(doc, en, g.kod, g.zestawy, function (li, z) {
                    li.appendChild(kule(doc, en, g.kod, z, null));
                    li.appendChild(akcje.wiersz(g.kod, z));
                }));
                miejsce.appendChild(sekcja);
            });
            if (eksportPrzycisk) { eksportPrzycisk.hidden = !gry.length; }
        }
        function rysuj() {
            var w = zestawyGier();
            licznik.textContent = licznikSkrotu(w.suma);
            if (licznikOpis) { licznikOpis.textContent = tekst(en, 'skrotLicznik', w.suma); }
            if (tekstSkrotu) { tekstSkrotu.textContent = w.suma ? etykietaZapisane : etykietaPusta; }
            licznik.hidden = w.suma === 0;
            box.hidden = false;
            if (html && html.classList) { html.classList.add('mk-jest'); }
            if (pusto) { pusto.hidden = w.suma > 0; }
            if (wskazowka) {
                // Fala 6A: jednorazowa informacja „prywatny notatnik” — do zamkniecia
                // krzyzykiem albo pierwszego otwarcia panelu (panel mowi to samo).
                // Bez dostepu do localStorage nie pokazujemy (i tak nic sie nie zapisze).
                var widziana = wskazowkaSesja;
                try { widziana = widziana || root.localStorage.getItem(KLUCZ_WSKAZOWKA) === '1'; } catch (e) { widziana = true; }
                wskazowka.hidden = widziana;
                zapasWskazowki();
            }
            if (otwarty() && widok === 'lista') { rysujPanel(w.gry); }
        }
        /** Widoczna informacja podnosi zapas pod stopka o swoja wysokosc — koniec strony
            da sie przewinac nad nia, nic nie zostaje trwale zasloniete. */
        function zapasWskazowki() {
            if (!html || !html.style) { return; }
            // Podpowiedź jest teraz wewnątrz dialogu, nie nad pływającym skrótem.
            html.style.removeProperty('--mk-wskazowka-wys');
        }
        function schowajWskazowke() {
            if (!wskazowka || wskazowka.hidden) { return; }
            wskazowka.hidden = true; wskazowkaSesja = true;
            try { root.localStorage.setItem(KLUCZ_WSKAZOWKA, '1'); } catch (e) { /* bez pamięci */ }
            zapasWskazowki();
        }
        function pokazDialog() {
            if (typeof panel.showModal === 'function') {
                try { if (!panel.open) { panel.showModal(); } } catch (e) { panel.setAttribute('open', ''); }
            } else { panel.setAttribute('open', ''); }
        }
        function otworzPanel(pomoc) {
            zZewnatrz = null;
            var w = zestawyGier();
            rysujPanel(w.gry);
            pokazWidok(pomoc ? 'pomoc' : (w.suma ? 'lista' : 'formularz'));
            pokazDialog();
            przycisk.setAttribute('aria-expanded', 'true');
            if (zamknij && typeof zamknij.focus === 'function') { zamknij.focus(); }
        }
        function zamknijPanel() {
            przycisk.setAttribute('aria-expanded', 'false');   // od razu; zdarzenie `close` przychodzi asynchronicznie
            if (typeof panel.close === 'function' && panel.open) { panel.close(); } else { panel.removeAttribute('open'); poZamknieciu(); }
        }
        function poZamknieciu() {
            schowajWskazowke();
            akcje.reset();
            komunikat('');
            kopiaWzor = null; if (zapiszPrzycisk) { zapiszPrzycisk.disabled = false; }
            przycisk.setAttribute('aria-expanded', 'false');
            var powrot = zZewnatrz && zZewnatrz.powrot;
            zZewnatrz = null;
            if (powrot && doc.contains(powrot) && typeof powrot.focus === 'function') { powrot.focus(); return; }
            if (!box.hidden && typeof przycisk.focus === 'function') { przycisk.focus(); }
        }
        przycisk.addEventListener('click', function () { if (otwarty()) { zamknijPanel(); } else { otworzPanel(false); } });
        // Przycisk „?” obok skrotu zdjety w Fali 6A — pomoc jest zakladka panelu.
        if (wskazowkaZamknij) { wskazowkaZamknij.addEventListener('click', function () {
            schowajWskazowke();
            if (zamknij && typeof zamknij.focus === 'function') { zamknij.focus(); }
        }); }
        Array.prototype.forEach.call(panel.querySelectorAll('[data-mk-widok]'), function (b) { b.addEventListener('click', function () {
            var cel = b.getAttribute('data-mk-widok');
            if (cel === 'formularz') { nowyFormularz(); } else { pokazWidok(cel); }
        }); });
        if (eksportPrzycisk) { eksportPrzycisk.addEventListener('click', function () {
            akcje.wyczyscCofnij();
            var k = eksportujPlik(doc, S, en, panel); komunikat(k.t, k.zly);
        }); }
        if (importPrzycisk) {
            // Jeden podgląd importu w centrum, także dla dawnych formatów.
            importPrzycisk.addEventListener('click', function () { akcje.wyczyscCofnij(); zamknijPanel(); });
        }
        var anuluj = panel.querySelector('[data-mk-anuluj]');
        if (anuluj) { anuluj.addEventListener('click', function () {
            edytowany = null; kopiaWzor = null; if (poleGra) { poleGra.disabled = false; } if (zapiszPrzycisk) { zapiszPrzycisk.disabled = false; }
            if (zZewnatrz) { zamknijPanel(); return; }
            pokazWidok('lista');
        }); }
        var losujPrzycisk = panel.querySelector('[data-mk-losuj]');
        var czestePrzycisk = panel.querySelector('[data-mk-czeste]');
        if (czestePrzycisk) { czestePrzycisk.addEventListener('click', function () {
            var r = S.reguly(poleGra.value), api = root.PewniakiNajczestsze;
            if (!r || !api || typeof api.wybierz !== 'function') { bladForm(t6(en, 'nieZapisano')); return; }
            czestePrzycisk.disabled = true;
            czestePrzycisk.setAttribute('aria-busy', 'true');
            var glowneIle = r.kod === 'multi-multi' ? 10 : r.pick;
            var zadania = [api.wybierz(r.kod, r.pula, glowneIle, 'numbers', 25)];
            if (r.dodatkowe) { zadania.push(api.wybierz(r.kod, r.dodatkowe.pula, r.dodatkowe.ile, 'special', 25)); }
            Promise.all(zadania).then(function (wyniki) {
                if (poleGra.value !== r.kod) { return; }
                poleLiczby.value = wyniki[0].join(' ');
                poleDodatkowe.value = r.dodatkowe ? wyniki[1].join(' ') : '';
                bladForm('');
                sprawdzKopie();
            }).catch(function () {
                bladForm(jst("moje_zestawy_js.f0077e432838"));
            }).then(function () {
                czestePrzycisk.disabled = false;
                czestePrzycisk.removeAttribute('aria-busy');
            });
        }); }
        if (losujPrzycisk) { losujPrzycisk.addEventListener('click', function () {
            var r = S.reguly(poleGra.value); if (!r) { return; }
            poleLiczby.value = losuj(r.pula, r.kod === 'multi-multi' ? 10 : r.pick).join(' ');
            poleDodatkowe.value = r.dodatkowe ? losuj(r.dodatkowe.pula, r.dodatkowe.ile).join(' ') : '';
            bladForm('');
            sprawdzKopie();
        }); }
        if (forma) { forma.addEventListener('submit', function (e) {
            e.preventDefault();
            var kod = poleGra.value, glowne = liczbyZPola(poleLiczby), dodatkowe = liczbyZPola(poleDodatkowe), r = S.reguly(kod);
            var n = S.normalizuj(kod, glowne, dodatkowe);
            if (!n.ok || glowne.length !== n.liczby.length || dodatkowe.length !== n.dodatkowe.length || (r && r.dodatkowe && dodatkowe.length !== r.dodatkowe.ile)) {
                bladForm(t6(en, 'bladForm')); return;
            }
            if (sprawdzKopie()) { bladForm(t6(en, 'kopiaTaSama')); return; }
            var w = edytowany ? S.edytuj(kod, edytowany.id, { nazwa: poleNazwa.value, liczby: glowne, dodatkowe: dodatkowe })
                : S.dodaj(kod, { nazwa: poleNazwa.value, liczby: glowne, dodatkowe: dodatkowe }, 'panel');
            if (!w.ok) {
                bladForm(w.blad === 'duplikat' ? t6(en, 'duplikat') : (w.blad === 'limit' ? t6(en, 'limit', LIMIT) : (w.blad === 'niedostepny' ? tekst(en, 'niedostepny')
                    : (w.blad === 'miejsce' ? tekst(en, 'miejsce') : t6(en, 'nieZapisano')))));
                return;
            }
            if (!edytowany) { S.zdarzenie('my_ticket_save', kod, 'centrum', w.liczba); }
            akcje.wyczyscCofnij();
            edytowany = null; kopiaWzor = null; poleGra.disabled = false; if (kopiaOpis) { kopiaOpis.hidden = true; }
            if (zZewnatrz) {
                var cb = zZewnatrz.poZapisie;
                zamknijPanel();
                if (typeof cb === 'function') { cb(t6(en, 'zapisano')); }
                return;
            }
            pokazWidok('lista');
            komunikat(t6(en, 'zapisano'));
        }); }
        if (zamknij) { zamknij.addEventListener('click', zamknijPanel); }
        panel.addEventListener('close', poZamknieciu);
        panel.addEventListener('cancel', function (e) { if (e && e.preventDefault) { e.preventDefault(); } zamknijPanel(); });
        // Klik w tlo (::backdrop trafia w sam <dialog>, nie w jego dzieci).
        panel.addEventListener('click', function (e) { if (e.target === panel) { zamknijPanel(); } });
        panel.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !e.defaultPrevented && !otwartyNatywnie()) { zamknijPanel(); } });
        function otwartyNatywnie() { return typeof panel.showModal === 'function'; }

        // Dolna reklama zakotwiczona (Google): odstep = jej wysokosc nad dolna krawedzia.
        var odstepZaplanowany = false;
        function odstepReklamy() {
            odstepZaplanowany = false;
            var ins = doc.querySelector('ins[data-anchor-status="displayed"], ins[data-anchor-shown="true"]');
            var px = 0;
            if (ins && typeof ins.getBoundingClientRect === 'function') {
                var r = ins.getBoundingClientRect(), wys = root.innerHeight || 0;
                if (r.height > 0 && r.top < wys && r.bottom >= wys - 2) { px = Math.round(wys - r.top); }
            }
            var nowa = px > 0 ? px + 'px' : '';
            if (box.style.getPropertyValue('--mk-odstep-dol') === nowa) { return; }   // bez zbednych mutacji
            if (nowa) { box.style.setProperty('--mk-odstep-dol', nowa); } else { box.style.removeProperty('--mk-odstep-dol'); }
        }
        function zaplanujOdstep() {
            if (odstepZaplanowany) { return; }
            odstepZaplanowany = true;
            if (typeof root.requestAnimationFrame === 'function') { root.requestAnimationFrame(odstepReklamy); } else { root.setTimeout(odstepReklamy, 50); }
        }
        if (typeof root.MutationObserver === 'function' && doc.body) {
            try {
                new root.MutationObserver(function (changes) {
                    // Table rendering changes thousands of cells. It does not
                    // move the Google anchor: avoid a forced layout for each
                    // batch. Only an anchor change or a new ad needs a check.
                    var adChanged = changes.some(function (change) {
                        if (change.type === 'attributes') { return true; }
                        return Array.prototype.some.call(change.addedNodes, function (node) {
                            return node.nodeType === 1 && (node.matches('ins') || node.querySelector('ins'));
                        }) || Array.prototype.some.call(change.removedNodes, function (node) {
                            return node.nodeType === 1 && (node.matches('ins[data-anchor-status], ins[data-anchor-shown]') || node.querySelector('ins[data-anchor-status], ins[data-anchor-shown]'));
                        });
                    });
                    if (adChanged) { zaplanujOdstep(); }
                }).observe(doc.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-anchor-status', 'data-anchor-shown'] });
            } catch (e) { /* bez obserwatora: odstep tylko przy starcie i zmianie rozmiaru */ }
        }
        if (root.addEventListener) { root.addEventListener('resize', zaplanujOdstep); }
        zaplanujOdstep();

        /* Centrum (6B) otwiera TEN SAM formularz: dodanie, edycja, duplikat.
           Po zapisie dialog sie zamyka, a centrum dostaje komunikat; fokus wraca
           na przycisk, ktory otworzyl formularz. */
        panelApi = {
            formularz: function (kod, zestaw, kopiaZ, opcje) {
                schowajWskazowke();
                nowyFormularz(kod, zestaw, kopiaZ);
                // Fala 7B (26.09.2026): wstepne wypelnienie NOWEGO zestawu (np. wynik
                // Multi Multi: 20 liczb, a kupon ma 1-10) — bez semantyki kopii;
                // zapis i tak przechodzi zwykla walidacja formularza i magazynu.
                if (opcje && opcje.wstepne && !zestaw && !kopiaZ) {
                    poleNazwa.value = String(opcje.wstepne.name || '');
                    poleLiczby.value = (opcje.wstepne.numbers || []).join(' ');
                    poleDodatkowe.value = (opcje.wstepne.extra || []).join(' ');
                    sprawdzKopie();
                    if (opcje.wstepne.info) { komunikat(String(opcje.wstepne.info)); }
                }
                zZewnatrz = { poZapisie: opcje && opcje.poZapisie, powrot: opcje && opcje.powrot };
                pokazDialog();
                przycisk.setAttribute('aria-expanded', 'true');
                if (poleGra && !poleGra.disabled) { poleGra.focus(); } else if (poleNazwa) { poleNazwa.focus(); }
            },
            sprawdzarka: sprawdzarka, analizatory: analizatory
        };

        doc.addEventListener(ZDARZENIE, rysuj);
        rysuj();
    }

    var instancja = null;
    function daneGier(doc) {
        var el1 = doc.getElementById('moje-zestawy-gry');
        if (!el1) { return []; }
        try { var d = JSON.parse(el1.textContent || '[]'); return Array.isArray(d) ? d : []; } catch (e) { return []; }
    }
    function czyEn(doc) {
        var skrot = doc && doc.querySelector ? doc.querySelector('[data-mk-skrot]') : null;
        var jezyk = skrot ? skrot.getAttribute('data-mk-lang') : '';
        if (!jezyk && doc && doc.documentElement) { jezyk = doc.documentElement.lang || ''; }
        // Wersje rynkowe DE/NL/ES mają tłumaczony szablon panelu; dla dynamicznych
        // komunikatów używamy bezpiecznego angielskiego zamiast polskiego fallbacku.
        return /^(?:en|de|nl|es)(?:-|$)/i.test(jezyk || '');
    }

    /** Magazyn tej strony (jeden na dokument). */
    function sklepStrony() {
        var doc = root.document;
        if (!instancja && doc) { instancja = utworz({ gry: daneGier(doc), en: czyEn(doc), dokument: doc }); }
        return instancja;
    }

    // Nazwy automatyczne: numer, data i pochodzenie; stare podpisy pozostaja bez zmian.
    function krotkaNazwa(en, indeks, zrodlo, data) {
        var opis = String(zrodlo || '').toLowerCase();
        var skrot = /rytm|rhythm/.test(opis) ? (jst("moje_zestawy_js.53b2889c36fb"))
            : /cz.st|frequen/.test(opis) ? (jst("moje_zestawy_js.5a88ce1fe1a9"))
            : /krocz|rolling/.test(opis) ? (jst("moje_zestawy_js.d32067e6d392"))
            : /histor|wygran|best|najlepsz/.test(opis) ? 'HIST'
            : /generator|losow|random/.test(opis) ? (jst("moje_zestawy_js.766e105124d4"))
            : /wynik|result/.test(opis) ? (jst("moje_zestawy_js.5e488c24c238"))
            : /anal/.test(opis) ? 'ANAL'
            : /sprawdz/.test(opis) ? (jst("moje_zestawy_js.672df2afa561"))
            : /import/.test(opis) ? 'IMP' : (jst("moje_zestawy_js.ae0693d698e1"));
        var d = data || new Date();
        var dzien = ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2);
        return ((jst("moje_zestawy_js.b5d171e9727f")) + (indeks + 1) + ' ' + dzien + ' ' + skrot).slice(0, 15);
    }

    function przygotujImport(kod, dane, przycisk) {
        var S = sklepStrony(), r = S && S.reguly(kod), doc = root.document;
        var en = czyEn(doc), wrap = przycisk && przycisk.closest('[data-mz-import-wrap]');
        var status = wrap && wrap.querySelector('[data-mz-import-status]');
        function powiedz(pl, eng) { if (status) { status.textContent = en ? eng : pl; } }
        var ns = r && dane && normalizujListe(dane.numbers, r.pula);
        var extra = r && dane && (dane.extra || []);
        if (!ns || !ns.length || !Array.isArray(extra) || (extra.length && (!r.dodatkowe || !normalizujListe(extra, r.dodatkowe.pula)))) {
            powiedz(jst("moje_zestawy_js.literal.9bf5d67971da"), jst("ui.a2a2dc111303a0d5")); return false;
        }
        if (!panelApi) { powiedz(jst("moje_zestawy_js.literal.a9ecb7bff5f3"), jst("ui.09c469347d83f3dd")); return false; }
        var info = jst("moje_zestawy_js.9ee8f98a5b73");
        if (dane.plus) { info += jst("moje_zestawy_js.f8d88b728563"); }
        panelApi.formularz(kod, null, null, { powrot: przycisk, wstepne: { numbers: ns, extra: extra.slice(), name: krotkaNazwa(en, S.lista(kod).length, dane.name || 'import'), info: info } });
        powiedz(jst("moje_zestawy_js.literal.9eb322c7ebca"), jst("ui.fc355a8c526eba28"));
        return true;
    }

    function startStrony(doc) {
        function start() {
            if (!doc.getElementById('moje-zestawy-gry')) { return; }
            var S = sklepStrony(), en = czyEn(doc);
            S.migruj();
            // Fala 6A: przekazanie z panelu odbieramy RAZ, zanim ruszy ktorykolwiek widok.
            przekazStrony = odbierzPrzekaz();
            var g = doc.querySelector('[data-mz-generator]');
            if (g) { widokGenerator(doc, S, en, g); }
            var s = doc.querySelector('[data-mz-sprawdzarka]');
            if (s) { widokSprawdzarka(doc, S, en, s); if (root.PewniakiSprawdzWszystkie) { root.PewniakiSprawdzWszystkie(doc, S, en); } }
            // Ukryte sekcje z zapisami uruchamiamy przy zblizeniu do ich miejsca.
            // Obserwowany jest rodzic: sam box bywa `hidden`, co blokuje IO.
            function przySekcji(w, wlacz) {
                var gotowe = false, observer = null, target = w.parentElement || w;
                function raz() { if (gotowe) return; gotowe = true; if (observer) observer.disconnect(); wlacz(); }
                target.addEventListener('pointerdown', raz, { capture: true, once: true, passive: true });
                target.addEventListener('focusin', raz, { capture: true, once: true });
                if (typeof root.IntersectionObserver === 'function') {
                    observer = new root.IntersectionObserver(function (entries) {
                        if (entries.some(function (e) { return e.isIntersecting; })) { root.setTimeout(raz, 0); }
                    }, { rootMargin: '200px' });
                    observer.observe(target);
                } else { root.setTimeout(raz, 0); }
            }
            Array.prototype.forEach.call(doc.querySelectorAll('[data-mz-wyniki]'), function (w) {
                przySekcji(w, function () { widokWyniki(doc, S, en, w); });
            });
            var mg = doc.querySelector('[data-mz-moje-gry]');
            if (mg) { widokMojeGry(doc, S, en, mg); }
            var sk = doc.querySelector('[data-mk-skrot]');
            if (sk) { widokSkrot(doc, S, en, sk); }
            Array.prototype.forEach.call(doc.querySelectorAll('[data-mz-import-wrap]'), function (w) { w.hidden = false; });
            doc.addEventListener('click', function (e) {
                var b = e.target.closest('[data-mz-import]'); if (!b) { return; }
                var d = null; try { d = JSON.parse(b.getAttribute('data-mz-import')); } catch (err) { /* Nie otwieramy uszkodzonego podgladu. */ }
                przygotujImport(b.getAttribute('data-gra'), d, b);
            });
            Array.prototype.forEach.call(doc.querySelectorAll('[data-analizator-root], [data-f6-podobne]'), function (w) {
                przySekcji(w, function () { widokWczytajDoAnalizy(doc, S, en, w); });
            });
            // Fala 6B: centrum „Moje kupony” startuje dopiero, gdy panel i magazyn sa gotowe.
            doc.documentElement.setAttribute('data-mz-gotowe', '1');
            if (typeof root.CustomEvent === 'function') { doc.dispatchEvent(new root.CustomEvent('pewniaki:zestawy-gotowe')); }
            // Zmiana w innej karcie tej samej przegladarki.
            if (root.addEventListener) {
                root.addEventListener('storage', function (e) {
                    if (e.key === KLUCZ && typeof root.CustomEvent === 'function') {
                        doc.dispatchEvent(new root.CustomEvent(ZDARZENIE, { detail: { game: null } }));
                    }
                });
            }
        }
        if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', start); } else { start(); }
    }

    return {
        KLUCZ: KLUCZ, KLUCZ_V1: KLUCZ_V1, KLUCZ_WIDZIANE: KLUCZ_WIDZIANE, WERSJA: WERSJA, LIMIT: LIMIT, ZDARZENIE: ZDARZENIE,
        reguly: reguly, porownaj: porownaj, przedzial: przedzial, utworz: utworz,
        idLosowania: idLosowania, ocenWidziane: ocenWidziane,
        sklep: sklepStrony, startStrony: startStrony, tekst: tekst, kule: kule, liczbaZestawow: liczbaZestawow,
        nazwaZGra: nazwaZGra,
        licznikSkrotu: licznikSkrotu,
        KLUCZ_PRZEKAZ: KLUCZ_PRZEKAZ, FORMAT_PAKIETU: FORMAT_PAKIETU,
        zapiszPrzekaz: zapiszPrzekaz, odbierzPrzekaz: odbierzPrzekaz, wezPrzekaz: wezPrzekaz, nazwaKopii: nazwaKopii,
        // Fala 6B-6D: to samo API dla centrum „Moje kupony” (bez drugiego magazynu).
        panel: function () { return panelApi; }, przygotujImport: przygotujImport, kontrolerAkcji: kontrolerAkcji, eksportujPlik: eksportujPlik, przeniesPlik: przeniesPlik,
        utworzLink: utworzLink, udostepnijLink: udostepnijLink, odczytajLink: odczytajLink, importujLink: importujLink, usunFragment: usunFragment,
        podepnijImport: podepnijImport, teksty6: t6, doAnalizatora: doAnalizatora
    };
});
